/* eslint-disable max-len */
/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { AfterViewInit, ApplicationRef, Component, OnInit, ComponentFactory, ComponentFactoryResolver, EventEmitter, Injector, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import * as L from 'leaflet';
import * as R from 'leaflet-responsive-popup';
import * as D from 'leaflet-draw';
import { of, Subscription } from 'rxjs';
import { ColorProfileOptions, MapPanData, UserSummary } from '../../map.interface';
import { MapsService } from '../../maps.service';
import { EmployeePopupComponent } from '../map-components/employee-popup/employee-popup.component';
import { JobPopupComponent } from '../map-components/job-popup/job-popup.component';
import { OrganizationPopupComponent } from '../map-components/organization-popup/organization-popup.component';
import 'leaflet.markercluster';
import { NgxTippyProps, NgxTippyService } from 'ngx-tippy-wrapper';
import { environment as env } from '../../../../../environments/environment';
import { OriginDestinationPopupComponent } from '../map-components/origin-destination-popup/origin-destination-popup.component';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { DispatchBoardService } from '../../../../../../projects/dispatch-board/src/app/components/dispatch-board/dispatch-board.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import _ from 'lodash';
import { TerritoryPopupComponent } from '../map-components/territory-popup/territory-popup.component';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { RouteFormOptions } from 'app/components/route-form/route-form.types';
import { DrawPopupComponent } from '../map-components/draw-popup/draw-popup.component';
import moment from 'moment';
import { JobFormComponent } from 'app/modules/jobs/job-form/job-form.component';
import { dataObj } from 'app/modules/jobs/job-form/job-form.type';
import { ZuperDialogService } from '@zuper/components/zuper-dialog';
import { TemplateService } from '../../../../../../projects/dispatch-board/src/app/core/services/template.service';
import { MatDialog } from '@angular/material/dialog';
import { catchError, debounceTime, distinctUntilChanged, filter, finalize, map, tap} from 'rxjs/operators';
const H = window['H'];

@Component({
  selector: 'app-map-main',
  templateUrl: './map-main.component.html',
  styleUrls: ['./map-main.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MapMainComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @Input() mapView: any;
  @Input() isDispatch?: boolean;
  @Input() colorProfileOptions: ColorProfileOptions;
  @Input() enableDrawToCreateRoute?: boolean = false;
  @Input() timezone?: string = moment.tz.guess();
  @Output() eventChange: EventEmitter<any> = new EventEmitter();
  @Output() jobSelected: EventEmitter<any> = new EventEmitter();
  @Output() routeCreated: EventEmitter<any> = new EventEmitter();
  @Output() drawCompleted: EventEmitter<any> = new EventEmitter();

  @ViewChild('routeAddJobConfirmationDialogContent', { static: true }) routeAddJobConfirmationDialogContent: TemplateRef<any>;

  searchAll: string = '';
  openDrawer: boolean = false;
  drawerModule: string = 'USER';
  moduleUid: string;
  previewOptions: any = {
    position: 'right',
    type: 'summary',
    mode: 'side',
    hasBackDrop: true
  };
  public tippyProps: NgxTippyProps = {
    allowHTML: true,
    theme: 'light',
    trigger: 'click',
    arrow: false,
    interactive: true,
    placement: 'bottom',
    popperOptions: {
      modifiers: [
        {
          name: 'preventOverflow',
          options: {
            padding: 0,
          },
        },
      ],
    },
    onShow: () => {
      this._dispatchBoardService.trackEvent('map_layer');
    }
  };
  pinOptions: any[] = [
    {
      key: 'jobs',
      displayName: 'text.jobs',
      showModule: this.utilityService.hasModuleAccess('JOB'),
      icon: 'ti-briefcase'
    },
    {
      key: 'routes',
      displayName: 'text.routes',
      showModule: this.utilityService.hasModuleAccess('MAPS'),
      icon: 'ti-route-vector'
    },
    {
      key: 'users',
      displayName: 'text.users',
      showModule: this.utilityService.hasModuleAccess('USER'),
      icon: 'ti-user'
    },
    {
      key: 'organizations',
      displayName: 'text.organizations',
      // showModule: this.utilityService.hasModuleAccess('ORGANIZATION')
      showModule: false,
      icon: 'ti-buildings'
    },
    {
      key: 'customers',
      displayName: 'customers.text',
      showModule: this.utilityService.hasModuleAccess('CUSTOMER'),
      icon: 'ti-users'
    },
    {
      key: 'properties',
      displayName: 'text.properties',
      showModule: this.utilityService.hasModuleAccess('PROPERTY'),
      icon: 'ti-building'
    },
    {
      key: 'assets',
      displayName: 'asset.text',
      showModule: this.utilityService.hasModuleAccess('ASSETS'),
      icon: 'ti-cube'
    },
    {
      key: 'service_territories',
      displayName: 'text.service_territories',
      showModule: this.utilityService.hasModuleAccess('MAPS'),
      icon: 'ti-flag-3'
    }
  ];
  pinOptionState: any = {
    'jobs': false,
    'routes': false,
    'users': false,
    'organizations': false,
    'properties': false,
    'customers': false,
    'service_territories': false,
    'assets': false
  };
  actualPinState: any;
  markerCluster: any = L.markerClusterGroup({
    animate: false,
    animateAddingMarkers: false,
    chunkedLoading: true,
    chunkDelay: 50
  });
  platform: any;
  currentRoute: any;
  openRouteDetails: boolean = false;
  allRoutes: any[] = [];
  currentTitleType: string = 'DEFAULT';
  openJob: boolean = false;
  jobObject: any = {};
  jobData: any = {};
  masterRouteCopy: any = {};
  allSelectedMarkers: any[] = [];
  openNewRoute: boolean = false;
  isJobSelectedForRouteAssignment: boolean = false;
  currentPolyline = { popup: null, routeDetails: null };
  customJobSelection = { enable: false, selectedJobMarkers: [], selectedJobUids: [], selectedJobAndMarker: {} };
  drawOnMapNavbarData = { toggleNavBar: false, selectedJobs: [], selectedJobUids: [], selectedRoute: null, selectedPolylinePopupInstance: null, routeHomeMarkerInstance: null };
  routeJobConfirmationDialogData = { dialogInstance: null, jobs: {}, selectedJobCount: 0, geoCords: {}, selectedRoute: null};
  jobMarkersMap = new Map<string, any>();
  routeMarkerLocations: Map<string, number> = new Map();;
  routeHomeMarkersMap = new Map<string, any>();
  assetMarkersMap = new Map<string, any>();
  employeeMarkersMap = new Map<string, any>();
  propertyMarkersMap = new Map<string, any>();
  customerMarkersMap = new Map<string, any>();
  organizationMarkersMap = new Map<string, any>();
  mapSettings: any = {
    'overlay_routes': false,
    'overlay_territories': false
  };
  routeFormOption: RouteFormOptions = {
    state: 'new',
    header: 'route.create'
  };

  private sidebarState: Subscription;
  private markerState: Subscription;
  private mapResizeSubscription: Subscription;
  private mapFitBoundByGeoCordsSubscription: Subscription;
  private showOnMapSubscription: Subscription;
  private clearDrawLayerSubscription: Subscription;
  private map: any;
  private tileLayer: any;
  // eslint-disable-next-line max-len
  private satelliteUrl: string = null;
  private mapTileUrl: string = window['mapTileUrl'];
  private activeGeoCords: number[];

  private drawerPreviewUid: Subscription;

  private employeeGroupsMarker: any[] = [];
  private employeeLayerGroup: any = L.layerGroup();;
  private employeeLocationData: Subscription;

  private assetGroupsMarker: any[] = [];
  private assetLayerGroup: any = L.layerGroup();;
  private assetLocationData: Subscription;

  private propertyLocationData: Subscription;
  private propertyGroupsMarkers: any[] = [];
  private propertyLayerGroup: any = L.layerGroup();;

  private jobLocationData: Subscription;
  private jobGroupsMarker: any[] = [];
  private jobLayerGroup: any = L.layerGroup();
  private jobDrawer: Subscription;

  private organizationLocationData: Subscription;
  private organizationGroupsMarker: any[] = [];
  private organizationLayerGroup: any = L.layerGroup();;

  private customerLocationData: Subscription;
  private customerGroupsMarker: any[] = [];
  private customerLayerGroup: any = L.layerGroup();;

  private routeLocationData: Subscription;
  private routeLayerGroup: any = L.layerGroup();;

  private serviceTerritoryLocationData: Subscription;
  private territoryDrawer: Subscription;
  private territoryLayerGroup: any = L.layerGroup();;
  private territoryGroup: any[] = [];

  private mainGroupsMarker: any[] = [];
  private mainLayerGroup: any;
  private mapTerritoryDetails: any = {};
  public serviceTerritory: any[] = [];

  //Draw on Map
  private drawControl: any;
  private drawnLayers: any;
  routeCreationTimezone: any = moment.tz.guess();
  defaultJobMarkerIcon = L.divIcon({
    className: 'custom-div-icon',
    html: this._MapService.getDefaultJobIcon(),
    iconSize: [40, 52],
    iconAnchor: [15, 40]
  });
  defaultCustomerIcon = L.divIcon({
    className: 'custom-div-icon',
    html: this._MapService.getDefaultCustomerIcon(),
    iconSize: [40, 52],
    iconAnchor: [15, 40]
  });

  defaultAssetIcon =  L.divIcon({
    className: 'custom-div-icon',
    html: this._MapService.getDefaultAssetIcon(),
    iconSize: [40, 52],
    iconAnchor: [15, 42]
  });
  defaultPropertyIcon =  L.divIcon({
    className: 'custom-div-icon',
    html: this._MapService.getDefaultPropertyIcon(),
    iconSize: [40, 52],
    iconAnchor: [15, 40]
  });

  activeTool: string | null = null;
  isDrawing = false;
  toolButtons: any[] = [];
  floatingActionButton = { infoMessage: '', showInfo: false, showClearBtn: false, lastActiveTool: null };

  //Legend
  legendDetails = { jobs: {}, customers: {}, assets: {}, properties: {} };
  currentCenter: L.LatLng | null = null;
  currentBound: L.LatLngBounds | null = null;
  previousZoom: number = -1;


  constructor(
    private _MapService: MapsService,
    private _toast: HotToastService,
    private _resolve: ComponentFactoryResolver,
    private _injector: Injector,
    private _appRef: ApplicationRef,
    private _tippyService: NgxTippyService,
    private _localStorageService: LocalStorageService,
    private _dataCollectorService: DataCollectorService,
    private _dispatchBoardService: DispatchBoardService,
    private _dispatchTemplateBoardService: TemplateService,
    private _zuperDrawerService: ZuperDrawerService,
    public utilityService: UtilityService,
    public zuperDialogService: ZuperDialogService,
    private matDialog: MatDialog

  ) {
    this.satelliteUrl = this._MapService.satelliteUrl;
   }

  private compilePopup(component, onAttach): any {
    const compFactory: ComponentFactory<Component> = this._resolve.resolveComponentFactory(component);
    const compRef = compFactory.create(this._injector);
    if (onAttach) { onAttach(compRef); }

    this._appRef.attachView(compRef.hostView);
    compRef.onDestroy(() => this._appRef.detachView(compRef.hostView));

    const div = document.createElement('div');
    div.appendChild(compRef.location.nativeElement);
    return div;
  }

  setTileLayer(type: string, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.map.removeLayer(this.tileLayer);
    this.currentTitleType = type;
    if (type === 'SATELLITE') {
      this.tileLayer = L.tileLayer(this.satelliteUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    } else if (type === 'DEFAULT') {
      this.tileLayer = L.tileLayer(this.mapTileUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    }
  }

  pinOptionChange(key: string): void {
    this.pinOptionState[key] = !this.pinOptionState[key];
  }

  getPinValue(key): boolean {
    return this.pinOptionState[key];
  }

  setOptionState(): void {
    const metaData = this._localStorageService.getLocalStorage('dispatch_board_metadata');
    if(this._dispatchBoardService.activeDispatchTab === 'JOBS') {
      if (this._dispatchBoardService.enableMapLayerByDefault.jobs) {
        metaData.map.layers.jobs = true;
      }
      if (this._dispatchBoardService.enableMapLayerByDefault.serviceTerritory) {
        metaData.map.layers.service_territories = true;
      }

    }
    else if(this._dispatchBoardService.activeDispatchTab === 'ROUTES') {
      if(this._dispatchBoardService.enableMapLayerByDefault.routes) {
        metaData.map.layers.routes = true;
      }
      if(this._dispatchBoardService.enableMapLayerByDefault.routesJob) {
        metaData.map.layers.jobs = true;
      }
      if (this._dispatchBoardService.enableMapLayerByDefault.serviceTerritory) {
        metaData.map.layers.service_territories = true;
      }
    }
    if (metaData?.map?.layers) {
      this.actualPinState = metaData.map.layers;
    }
    if (!this.actualPinState) {
      this.pinOptionState = {
        'jobs': false,
        'routes': false,
        'users': false,
        'organizations': false,
        'properties': false,
        'customers': false,
        'service_territories': false,
        'assets': false
      };
    } else {
      this.pinOptionState = { ...this.actualPinState };
    }
  }

  openFilter(): void {
    this.eventChange.emit({
      'event': 'FILTER',
    });
  }

  openSettings(): void {
    this.eventChange.emit({
      'event': 'SETTINGS',
    });
  }

  savePinState(): void {
    let metaData = this._localStorageService.getLocalStorage('dispatch_board_metadata');
    this.actualPinState = { ...this.pinOptionState };
    if(this._dispatchBoardService.activeDispatchTab === 'JOBS') {
      if (!this.pinOptionState.jobs) {
        this._dispatchBoardService.enableMapLayerByDefault.jobs = false;
      }
      if (!this.pinOptionState.service_territories) {
        this._dispatchBoardService.enableMapLayerByDefault.serviceTerritory = false;
      }
    }
    if(this._dispatchBoardService.activeDispatchTab === 'ROUTES') {
      if(!this.pinOptionState.routes) {
        this._dispatchBoardService.enableMapLayerByDefault.routes = false;
      }
      if(!this.pinOptionState.jobs) {
        this._dispatchBoardService.enableMapLayerByDefault.routesJob = false;
      }
      if (!this.pinOptionState.service_territories) {
        this._dispatchBoardService.enableMapLayerByDefault.serviceTerritory = false;
      }
    }
    if (metaData) {
      metaData['map']['layers'] = this.actualPinState;
    } else {
      metaData = {
        'map': {
          'enable_map_view': true,
          'nearby_jobs': true,
          'layers': this.actualPinState
        }
      };
    }
    this._MapService.toggleMapDrawTool(this.actualPinState?.routes);
    const payload = { 'meta_data': { 'module': 'SCHEDULE', 'key': 'DISPATCH_BOARD_V3', 'value': JSON.stringify(metaData) } };
    this._dataCollectorService.postData(this._dispatchBoardService.metaDataUrl, payload)
      .subscribe({
        next: (response) => {
          this._localStorageService.setLocalStorage('dispatch_board_metadata', metaData);
          this.eventChange.emit({
            'event': 'PIN',
            'data': this.actualPinState
          });
          this._MapService.mapCurrentLocation.next({ additionalData: { metaData: this._dispatchTemplateBoardService.metaData } });
          this._tippyService.hideAll();
        },
        error: (err) => {
          if (err?.message) {

          } else if (err?.data?.message) {

          } else {

          }
        }
      });
  }

  cancelPinState(): void {
    this._tippyService.hideAll();
  }

  clearMapSearch(): void {
    this.searchAll = '';
    if (this.mainLayerGroup) {
      // this.map.removeLayer(this.organizationLayerGroup);
      this.markerCluster.removeLayer(this.mainLayerGroup);
      this.mainLayerGroup = '';
      this.mainGroupsMarker = [];
      this.markerCluster.refreshClusters();
    }
  }

  moveToTerritory(territory: any): void {
    if (territory?.territory_coordinates?.length === 2) {
      this.map.fitBounds(territory?.territory_coordinates);
    } else if (territory?.territory_coordinates?.length > 2) {
      const bounds = L.polygon(territory?.territory_coordinates).getBounds();
      this.map.fitBounds(bounds);
    } else if (territory?.territory_type === 'RADIUS' && territory?.territory_radius?.geo_cordinates?.length > 0 && territory?.territory_radius?.radius) {
      this.map.setView(territory?.territory_radius?.geo_cordinates, 15);
    }
  }

  onAutocompleteSelected(result: any): void {
    if (result?.address) {
      this.activeGeoCords = [result.address.geoLocation.latitude, result.address.geoLocation.longitude];
      if (!this.isDispatch) {
        this.map.setView([this.activeGeoCords[0], this.activeGeoCords[1]], 16);
        //Initializing Icon
        const icon = L.divIcon({
          className: 'custom-div-icon',
          html: `<img style="width:100%" src="assets/images/svgs/map_main_marker.svg" alt="main marker icon">`,
          iconSize: [40, 52],
          iconAnchor: [15, 42]
        });


        const marker = L.marker(this.activeGeoCords, {
          icon: icon
        });

        //Grouping markers
        this.mainGroupsMarker.push(marker);

        //Adding the group to map
        this.mainLayerGroup = L.layerGroup(this.mainGroupsMarker);
        this.markerCluster.addLayer(this.mainLayerGroup);
        this.map.addLayer(this.markerCluster);

      } else {
        this.map.setView([this.activeGeoCords[0], this.activeGeoCords[1]], 13);
      }
    }
  }

  previewDataEventHandler(event: any): void {
    if (event?.action === 'UPDATE' && event?.job) {
      this._MapService.updateList.next({
        module: 'JOB'
      });
    }
    if (event.drawerClosed) {
      this.openDrawer = false;
    }
  }

  handleMapMovement(event: any): void {
    const target = event?.target as L.Map;
    if (!target) { return; }
    const newCenter = target.getCenter();
    const zoom = target.getZoom() || 0;
    const distanceFromLastCenter = this.currentCenter ? newCenter.distanceTo(this.currentCenter) : 0;
    if (distanceFromLastCenter >= this._MapService.getDynamicRadius(this.previousZoom) || zoom !== this.previousZoom) {
      this.currentCenter = newCenter;
      this.currentBound = target.getBounds();
      const data: MapPanData = {
        geo_cords: [newCenter.wrap().lat, newCenter.wrap().lng],
        data: event,
        distance: distanceFromLastCenter,
        zoom: zoom,
        isWithinBound: false,
        radius: this._MapService.getDynamicRadius(zoom),
      };
      if (this.isDispatch) {
        data.additionalData = { metaData: this._dispatchTemplateBoardService.metaData };
      }
      this._MapService.mapCurrentLocation.next(data);
      this.previousZoom = zoom;
    }
  }

  handleZoomChange(mapInstance: any): void {
    const zoom = mapInstance.getZoom();
    const newCenter = mapInstance.getCenter();
    const distanceFromLastCenter = this.currentCenter ? newCenter.distanceTo(this.currentCenter) : 0;
    const dynamicRadius = this._MapService.getDynamicRadius(zoom);

    if (distanceFromLastCenter >= dynamicRadius * 0.5 || zoom !== this.previousZoom) {
      this.currentCenter = newCenter;
      const data: MapPanData = {
        geo_cords: [newCenter.wrap().lat, newCenter.wrap().lng],
        data: newCenter,
        distance: distanceFromLastCenter,
        zoom: zoom,
        isWithinBound: false,
        radius: dynamicRadius
      };
      this._MapService.mapCurrentLocation.next(data);
      this.previousZoom = zoom;
    }
  }

  initiateMapEventListener(): void {
    this.map.on('moveend', _.debounce((event: any) => this.handleMapMovement(event), 500));
    this.map.on('zoomend', _.debounce(() => this.handleZoomChange(this.map), 500));
  }

  stopMapEventListener(): void {
    this.map.off('moveend');
    this.map.off('zoomend');
  }

  private initMap(is_coords: boolean): void {
    let center; let zoom;
    if (is_coords) {
      center = this.activeGeoCords;
      zoom = 11;
    } else {
      center = [40.6000135, -25.2314079];
      zoom = 3;
    }

    this.map = L.map('map', {
      center: center,
      zoom: zoom,
      zoomControl: false,
      attributionControl: false,
      tms: true,
      worldCopyJump: true,
      minZoom: 3,
      preferCanvas: true
    });

    this.map.whenReady(()=>{
      this.eventChange.emit({
        event: 'MAP-LOADED'
      });
      this._MapService.initalMapCurrentLocation = is_coords ? this.activeGeoCords : [40.6000135, -25.2314079];
      this.addMapLegendButtonInToolbar();
      this.addCustomJobSelectButtonInToolbar();
      this.setDrawOnMapConfig();
      this.initializeDrawToolButtons();
    });

    this.initiateMapEventListener();
    L.control.zoom({ position: 'bottomright' }).addTo(this.map);
    this.tileLayer = L.tileLayer(this.mapTileUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    setTimeout(function(this) {
      window.dispatchEvent(new Event('resize'));
    }, 500);

    this.mapResizeSubscription = this._MapService.mapResizeIndicator.subscribe((result: any) => {
      if(result) {
        this.map?.invalidateSize();
      }
    });
    this.mapFitBoundByGeoCordsSubscription = this._MapService.mapFitBoundByGeoCords.subscribe((coordinates: any) => {
      if(coordinates) {
        const bounds = L.latLngBounds(coordinates);
        if (bounds && this.map) {
          this.map.fitBounds(bounds);
        }
      }
    });
    this.showOnMapSubscription = this._MapService.showOnMap.subscribe({
      next: (event: any) => {
        try {
          if (event?.module && !_.isNil(event?.eventUid)) {
            if (event?.module === 'JOBS') {
              if (this.jobMarkersMap.size === 0) {
                this._MapService.openTooltip.jobUid = event?.eventUid;
                return;
              }
              this._MapService.openTooltip.routeUid = null;
              const marker = this.jobMarkersMap.get(event?.eventUid);
              this._MapService.openTooltip.jobUid = marker?.options?.job?.job_uid;
              if (marker) {
                this.setJobDetailsTooltipContent({ target: marker }, marker?.options?.job);
                this.openSpecificJobMarkerPopup(marker);
              }
              else {
                this._MapService.openTooltip.jobUid = null;
              }
            }
            else if (event?.module === 'ROUTES') {
              if (this.routeHomeMarkersMap.size === 0) {
                this._MapService.openTooltip.routeUid = event?.eventUid;
                return;
              }
              this._MapService.openTooltip.jobUid = null;
              const marker = this.routeHomeMarkersMap.get(event?.eventUid);
              this._MapService.openTooltip.routeUid = marker?.options?.route?.route_uid;
              if (marker) {
                this.map.setView(marker.getLatLng(), 16);
                marker.fire('click');
              }
              else {
                this._MapService.openTooltip.routeUid = null;
              }
            }
          }
        } catch (error) { }
      },
      error: (err: any) => { }
    });
    this.clearDrawLayerSubscription = this._MapService.clearDrawLayer.subscribe((isDeleted: boolean) => {
      if(isDeleted) {
        this.drawnLayers?.clearLayers();
        this.disableActiveTool();
      }
    });
    this.getMarkerState();
    this.getEmployeeLocationData();
    this.getAssetLocationData();
    this.getPropertyLocationData();
    this.getJobLocationData();
    this.getOrganizationLocationData();
    this.getCustomerLocationData();
    this.getPreview();
    this.getSidebarState();
    this.getRouteLocationData();
    this.getServiceTerritoryLocationData();
    this.toggleTerritoryDrawer();
    this.toggleNewJobDrawer();

  }

  setDrawOnMapConfig(): void {
    if (this.enableDrawToCreateRoute) {
      L.extend(D);
      this.drawnLayers = new L.FeatureGroup();
      this.map.addLayer(this.drawnLayers);
      const drawPluginOptions = {
        position: 'topright',
        draw: {
          polyline: false,
          polygon: {
            allowIntersection: false,
            shapeOptions: {
              color: '#6d9ddf'
            }
          },
          circle: {
            shapeOptions: {
              clickable: false
            }
          },
          rectangle: {
            showArea: false,
            shapeOptions: {
              clickable: false
            }
          },
          marker: false,
          circlemarker: false
        },
        edit: {
          featureGroup: this.drawnLayers,
          edit: false,
          remove: false
        }
      };
      this.drawControl = new L.Control.Draw(drawPluginOptions);
      this.drawControl.addTo(this.map);
      this.map.off('draw:created');
      this.map.on('draw:created', (event: any) => {
        const layer = event.layer;
        this.allSelectedMarkers = [];
        const mapLayers = Object.values(this.map._layers);
        let clusterChildMarkers = [];
        this.map.eachLayer((layer: any) => {
          const cluster = this.markerCluster.getVisibleParent(layer);
          if (cluster?.getAllChildMarkers) {
            const markersInCluster = cluster.getAllChildMarkers();
            clusterChildMarkers = [...clusterChildMarkers, ...markersInCluster];
          }
        });
        const mapLayersAndChildMarkers = [...mapLayers, ...clusterChildMarkers];
        mapLayersAndChildMarkers.forEach((marker) => {
          if (marker?.options?.job && !marker?.options?.isRouteJob) {
            const latLng = marker.getLatLng();
            if (layer instanceof L.Rectangle) {
              if (layer.getBounds().contains(latLng)) {
                this.allSelectedMarkers.push(marker);
              }
            } else if (layer instanceof L.Polygon) {
              if (this.isMarkerInsidePolygon(latLng, layer)) {
                this.allSelectedMarkers.push(marker);
              }
            } else if (layer instanceof L.Circle) {
              if (this.isMarkerInsideCircle(marker, layer)) {
                this.allSelectedMarkers.push(marker);
              }
            }
          }
        });
        this.allSelectedMarkers = _.unionBy(this.allSelectedMarkers, 'options.job.job_uid');
        //Construct marker
        if(this.isDispatch) {
          this.drawOnMapNavbarData.toggleNavBar = true;
          this.drawOnMapNavbarData.selectedJobs = this.allSelectedMarkers.map((marker: any) => ({ 'job': marker.options.job, 'geo_cords': marker?.getLatLng()}));
          this.drawOnMapNavbarData.selectedJobUids =   this.drawOnMapNavbarData.selectedJobs.map((jobDetails: any) => jobDetails?.job?.job_uid);
          this.isJobSelectedForRouteAssignment = !!this.drawOnMapNavbarData.selectedJobs?.length;
          this.showClearSelectionFloatingBtn();
        }
        else {
          const markerPopup: any = this.compilePopup(DrawPopupComponent, (c) => {
            c.instance.jobs = this.allSelectedMarkers.length;
            c.instance.createRoute.subscribe((res: any) => {
              if (res) {
                event?.layer?.closePopup();
                this.toggleNewRoute();
              }
            });
          });

          const popup = R.responsivePopup({ minWidth: 50, offset: [5, -35], maxWidth: 150 }).setContent(markerPopup);

          event.layer.bindPopup(popup).on('popupclose', () => {
            this.drawnLayers?.clearLayers();
          });
        }
        this.drawnLayers?.clearLayers();
        this.drawnLayers.addLayer(event.layer);

        setTimeout(() => {
          event.layer.openPopup();
        }, 10);
      });
      this.map.on('draw:deletestart', (event: any) => {
        this.drawnLayers?.clearLayers();
        this.clearDrawOnMap();
        this.drawCompleted.emit({
          type: 'delete',
          selectedJob: []
        });
      });
      this.map.on('draw:drawstart', (event: any) => {
        if (this.customJobSelection.enable) {
          this.customJobSelection.selectedJobMarkers.forEach((markers: any) => {
            markers.target.setIcon(this.getJobMarkerIcon(markers?.target?.options?.job));
            markers.target.unbindTooltip();
          });
          this.customJobSelection.enable = false;
          this.isJobSelectedForRouteAssignment = false;
          this.drawOnMapNavbarData.selectedJobs = [];
          this.drawOnMapNavbarData.selectedJobUids = [];
        }
      });
    }
  }

  initializeDrawToolButtons(): void {
    if (this.enableDrawToCreateRoute) {
      this.toolButtons = [
        { tool: 'polygon', element: document.querySelector('.leaflet-draw-draw-polygon') },
        { tool: 'rectangle', element: document.querySelector('.leaflet-draw-draw-rectangle') },
        { tool: 'circle', element: document.querySelector('.leaflet-draw-draw-circle') },
        { tool: 'custom', element: document.querySelector('.leaflet-control-select-job-button') }
      ];

      this.toolButtons.forEach((button: any) => {
        if (button.element) {
          button.element.addEventListener('click', () => this.toggleDrawTool(button.tool));
        }
      });
    }
  }

  toggleDrawTool(tool: string): void {
    if (this.activeTool === tool && this.isDrawing) {
      this.disableActiveTool();
      this.map.fire('draw:deletestart');
      this.activeTool = null;
      return;
    }

    if (this.isDrawing) {
      this.disableActiveTool();
      this.map.fire('draw:deletestart');
    }

    this.activeTool = tool;
    this.activateDrawingTool(tool);
    this.isDrawing = true;
  }

  activateDrawingTool(tool: string): void {
    const selectedTool = this.toolButtons.find(button => button.tool === tool);
    if (selectedTool) {
      this.removeFloatingClearSelection();
      if (tool === 'custom') {
        this.map.fire('custom:job:select:start');
        this.floatingActionButton.infoMessage = this.utilityService.getLocaleValue('dispatchBoard.map.route.multi_select_jobs', 'Click on jobs to multi-select');
      } else {
        this.drawControl._toolbars.draw._modes[tool].handler.enable();
        this.floatingActionButton.infoMessage = this.utilityService.getLocaleValue('dispatchBoard.map.route.draw_on_map', 'Draw on map to select Jobs');
      }
      if (!selectedTool.element.classList.contains('active')) {
        selectedTool.element.classList.add('active');
      }
      this.floatingActionButton.lastActiveTool = tool;
      this.floatingActionButton.showInfo = true;
    }
  }

  disableActiveTool(): void {
    const activeButton = this.toolButtons.find(button => button.tool === this.activeTool);
    if (activeButton) {
      if (this.activeTool === 'custom') {
        this.customJobSelection.enable = false;
        this.drawCompleted.emit({
          type: 'delete',
          selectedJob: []
        });
      } else {
        this.drawControl._toolbars.draw._modes[this.activeTool].handler.disable();
      }
      activeButton.element.classList.remove('active');
    }
    this.removeFloatingClearSelection();
    this.removeFloatingInfo();
    this.isDrawing = false;
  }

  addCustomJobSelectButtonInToolbar(): void {
    if (this.enableDrawToCreateRoute) {
      const CustomControl = L.Control.extend({
        options: {
          position: 'topright',
          interactive: false
        },
        onAdd: () => {
          const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-select-job');
          const buttonElement = L.DomUtil.create('a', 'leaflet-control-select-job-button flex items-center text-center', container);
          buttonElement.title = 'Select Jobs for Route Planning';
          buttonElement.innerHTML = `<span class="sr-only">Select Jobs for Route Planning</span>`;
          L.DomEvent.disableClickPropagation(container);
          L.DomEvent.disableScrollPropagation(container);
          return container;
        }
      });
      this.map.addControl(new CustomControl());
      this.map.on('custom:job:select:start', () => {
        this.customJobSelection = { enable: true, selectedJobMarkers: [], selectedJobUids: [], selectedJobAndMarker: {} };
        this.isJobSelectedForRouteAssignment = false;
        this.drawOnMapNavbarData.selectedJobs = [];
        this.drawOnMapNavbarData.selectedJobUids = [];
        this.drawnLayers?.clearLayers();
      });
      this.map.on('custom:job:select:end', () => {
        this.customJobSelection.enable = false;
        this.clearDrawOnMap();
        this.drawCompleted.emit({
          type: 'delete',
          selectedJob: []
        });
      });
    }
  }


  addMapLegendButtonInToolbar(): void {
    if (this.colorProfileOptions?.enableLegend) {
      const CustomControl = L.Control.extend({
        options: {
          position: 'bottomright',
          interactive: false
        },
        onAdd: () => {
          const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control custom-control-container legend-container border-none cursor-pointer bg-white');
          const buttonElement = L.DomUtil.create('a', 'flex items-center text-center bg-transparent legend-btn', container);
          buttonElement.title = 'Legend';
          buttonElement.innerHTML = `<span class="sr-only">Legend</span>`;

          // Add click event to toggle the panel
          buttonElement.onclick = (): any => {
            this._MapService.isLegendBarOpen = !this._MapService.isLegendBarOpen;
            this.toggleLegendPanel(container, this._MapService.isLegendBarOpen);
          };
          L.DomEvent.disableClickPropagation(container);
          L.DomEvent.disableScrollPropagation(container);
          return container;
        }
      });
      this.map.addControl(new CustomControl());
    }
  }

  toggleLegendPanel(legendContainer: HTMLElement, isLegendBarOpen: boolean): void {
    this._MapService.setMapLegendActiveState(legendContainer, isLegendBarOpen);
    this.eventChange.next({ event: 'LEGEND', isOpen: isLegendBarOpen, legendDetails: this.legendDetails });
  }

  removeAllCustomSelectedJobs(): void {
    this.customJobSelection.selectedJobMarkers.forEach((markers: any) => {
      markers.target.setIcon(this.getJobMarkerIcon(markers?.target?.options?.job));
      markers.target.unbindTooltip();
    });
    this.customJobSelection = { enable: false, selectedJobMarkers: [], selectedJobUids: [], selectedJobAndMarker: {} };
    this.updateCustomSelectedJobMarker();
  }

  addCustomJobSelection(jobMarker: any): any {
    const jobUid: string = jobMarker?.target?.options?.job?.job_uid;
    if (jobUid) {
      this.customJobSelection.selectedJobMarkers.push(jobMarker);
      this.customJobSelection.selectedJobUids.push(jobUid);
      this.customJobSelection.selectedJobAndMarker[jobUid] = jobMarker;
    }
  }

  removeCustomJobSelection(jobMarker: any): void {
    const jobUid: string = jobMarker?.target?.options?.job?.job_uid;
    if (jobUid) {
      this.customJobSelection.selectedJobMarkers = this.customJobSelection.selectedJobMarkers.filter((marker: any) => marker?.target?.options?.job?.job_uid !== jobUid);
      this.customJobSelection.selectedJobUids = this.customJobSelection.selectedJobUids.filter((job: any) => job !== jobUid);
      jobMarker.target.setIcon(this.getJobMarkerIcon(jobMarker?.target?.options?.job));
      delete this.customJobSelection.selectedJobAndMarker[jobUid];
    }
  }

  addOrRemoveSelectedJob(jobMarker: any): void {
    const jobUid: string = jobMarker?.target?.options?.job?.job_uid;
    if (jobUid) {
      if (this.customJobSelection.selectedJobUids.includes(jobUid)) {
        this.removeCustomJobSelection(jobMarker);
      }
      else {
        this.addCustomJobSelection(jobMarker);
      }
      this.refreshCustomSelectedJobMarker();
    }
  }

  refreshCustomSelectedJobMarker(): void {
    this.refreshDrawCompleteEvent();
    this.updateCustomSelectedJobMarker();
  }

  refreshDrawCompleteEvent(): void {
    this.drawOnMapNavbarData.selectedJobs = this.customJobSelection.selectedJobMarkers.map((marker: any) => ({ 'job': marker.target.options?.job, 'geo_cords': marker?.target?.getLatLng()}));
    this.drawOnMapNavbarData.selectedJobUids =   this.drawOnMapNavbarData.selectedJobs.map((jobDetails: any) => jobDetails?.job?.job_uid);
    this.isJobSelectedForRouteAssignment = !!this.drawOnMapNavbarData.selectedJobs?.length;
    if (this.drawOnMapNavbarData.selectedJobUids?.length) {
      this.showClearSelectionFloatingBtn();
    }
    else {
      this.removeFloatingClearSelection();
    }
  }

  clearDrawOnMap(disableTool: boolean = true, activateLastEnabledTool: boolean = false): void {
    this.drawOnMapNavbarData.toggleNavBar = false;
    this.drawOnMapNavbarData.selectedJobs = [];
    this.drawOnMapNavbarData.selectedJobUids = [];
    this.isJobSelectedForRouteAssignment = false;
    this.drawnLayers?.clearLayers();
    this.removeAllCustomSelectedJobs();
    this.removeFloatingClearSelection();
    this.removeFloatingInfo();
    if (disableTool) {
      this.disableActiveTool();
    }
    if (activateLastEnabledTool) {
      if (this.floatingActionButton.lastActiveTool) {
        this.activateDrawingTool(this.floatingActionButton.lastActiveTool);
      }
    }
    if (this.drawOnMapNavbarData.selectedPolylinePopupInstance) {
      this.drawOnMapNavbarData.selectedPolylinePopupInstance.closePopup();
      this.drawOnMapNavbarData.selectedPolylinePopupInstance.unbindPopup();
    }
    if(this.drawOnMapNavbarData.routeHomeMarkerInstance) {
      this.drawOnMapNavbarData.routeHomeMarkerInstance.target.closePopup();
      this.drawOnMapNavbarData.routeHomeMarkerInstance.target.unbindPopup();
    }
  }

  createRouteOnDraw(): void {
    this.drawCompleted.emit({
      type: 'create',
      selectedJob: this.drawOnMapNavbarData.selectedJobs
    });
    this.clearDrawOnMap();
  }

  updateCustomSelectedJobMarker(): void {
    this.customJobSelection.selectedJobMarkers.forEach((marker: any, index: number) => {
      marker.target.setIcon(this.getJobMarkerIconWithNumber(index + 1));
    });
  }

  getJobMarkerIconWithNumber(index: number): any {
    return L.divIcon({
      className: 'bg-transparent border-none',
      html: `<div class="bg-green-100 flex items-center justify-center border-green-600 border-2 w-full h-full rounded-full text-gray-700">
       <span>${index}</span>
      </div>`,
      iconSize: [36, 36],
      iconAnchor: [15, 42]
    });
  }

  getOrganizationLocationData(): void {
    this.organizationLocationData = this._MapService.organizationLocationData
      .pipe(map((res: any) => res?.filter((organizationDetails: any) => this.utilityService.isValidGeoCords(organizationDetails?.organization_address?.geo_cordinates))))
      .subscribe({
        next: (res) => {
          if (res) {
            const newOrganizationMarkersMap = new Map<string, any>();
            res.forEach(organizationDetails => newOrganizationMarkersMap.set(organizationDetails.organization_uid, organizationDetails));

            const markersToRemove = [];
            this.organizationMarkersMap.forEach((existingMarker, organizationUid) => {
              if (!newOrganizationMarkersMap.has(organizationUid)) {
                markersToRemove.push(existingMarker);
                this.organizationMarkersMap.delete(organizationUid);
              }
            });

            const markersToAdd = [];
            newOrganizationMarkersMap.forEach((organizationDetails, organizationUid) => {
              const existingMarker = this.organizationMarkersMap.get(organizationUid);
              if (existingMarker) {
                if (existingMarker?.options?.organization?.updated_at !== organizationDetails?.updated_at) {
                  markersToRemove.push(existingMarker);
                  this.organizationMarkersMap.delete(organizationUid);
                  const marker = this.createOrganizationMarker(organizationDetails);
                  if (marker) {
                    markersToAdd.push(marker);
                  }
                }
              } else {
                const marker = this.createOrganizationMarker(organizationDetails);
                if (marker) {
                  markersToAdd.push(marker);
                }
              }
            });
            if (markersToRemove?.length) {
              const layerGroupToRemove = L.layerGroup(markersToRemove);
              this.organizationLayerGroup.removeLayer(layerGroupToRemove);
              this.markerCluster.removeLayer(layerGroupToRemove);
            }

            if (markersToAdd?.length) {
              const newLayerGroup = L.layerGroup(markersToAdd);
              this.organizationLayerGroup.addLayer(newLayerGroup);
              this.markerCluster.addLayer(newLayerGroup);
            }

            if (this.map.hasLayer(this.markerCluster)) {
              this.markerCluster.refreshClusters();
            } else {
              this.map.addLayer(this.markerCluster);
            }
          }
        },
        error: (err) => {
          if (err?.data?.message) { }
        }
      });
  }

  createOrganizationMarker(organizationDetails: any): any {
    if (this.utilityService.isValidGeoCords(organizationDetails?.organization_address?.geo_cordinates)) {
      const icon = L.divIcon({
        className: 'custom-div-icon',
        html: `<img style="width:100%" src="assets/images/svgs/organization_marker.svg" alt="organization marker icon">`,
        iconSize: [40, 52],
        iconAnchor: [15, 42]
      });
      const marker = L.marker(organizationDetails?.organization_address?.geo_cordinates, {
        icon: icon,
        organization: organizationDetails
      });
      if (this.isDispatch) {
        marker.on('click', (organizationMarkerInstance: any) => {
          if (!organizationMarkerInstance.target.getPopup()) {
            this.bindMarkerPopup('organisation', organizationMarkerInstance, organizationDetails);
          }
          const popup = organizationMarkerInstance.target.getPopup();
          popup.on('remove', () => {
            organizationMarkerInstance.target.unbindPopup();
          });
        });
      } else {
        const markerPopup: any = this.compilePopup(OrganizationPopupComponent, (c) => { c.instance.data = organizationDetails; });
        const popup = R.responsivePopup({ minWidth: 280, offset: [5, -35] }).setContent(markerPopup);
        marker.bindPopup(popup);
      }

      this.organizationMarkersMap.set(organizationDetails.organization_uid, marker);
      return marker;
    };
    return null;
  }

  getMarkerPopupContent(module: 'job' | 'customer' | 'property' | 'organisation' | 'asset' | 'user' | 'territory', data: any): any {
    switch (module) {
      case 'customer': {
        return this._MapService.getCustomerPopup(data);
      }
      case 'asset': {
        return this._MapService.getAssetPopup(data);
      }
      case 'property' : {
        return this._MapService.getPropertyPopup(data);
      }
      case 'user': {
        return this._MapService.getEmployeeLocationPopup(data);
      }
      case 'territory': {
        return this._MapService.getServiceTerritoryPopup(data);
      }
    }
  }

  bindMarkerPopup(module: 'job' | 'customer' | 'property' | 'organisation' | 'asset' | 'user' | 'territory', markerInstance: any, data: any): void {
    if (module && markerInstance && data) {
      const markerPopup: any = this.getMarkerPopupContent(module, data);
      const popupContent = R.responsivePopup({ minWidth: 280, autoPan: true }).setContent(markerPopup);
      const existingPopup = markerInstance.target.getPopup();
      const popupOptions = {
        closeButton: true,
        minWidth: 250,
        offset: module === 'territory' ? [0, 0] : [5 , -35]
      };
      if (!existingPopup) {
        markerInstance.target.bindPopup(popupContent, popupOptions);
      }
      const popup = markerInstance.target.getPopup();
      if (popup) {
        if (module === 'territory') {
          popup.setLatLng(markerInstance?.latlng).openOn(this.map);
        }
        else {
          markerInstance.target.openPopup();
        }
        const popupElement = popup.getElement();
        if (popupElement) {
          const closeButton = popupElement.querySelector('.leaflet-popup-close-button');
          if (closeButton) {
            closeButton.removeEventListener('click', this.handleCloseButtonClick);
            closeButton.addEventListener('click', this.handleCloseButtonClick);
          }

          if (module === 'customer') {
            const createJobButton: HTMLElement = popupElement.querySelector('#customer-create-job-btn');
            const customerTitle: HTMLElement = popupElement.querySelector('#customer-title');
            if (createJobButton) {
              createJobButton.removeEventListener('click', this.handleCustomerCreateJobClick);
              createJobButton.addEventListener('click', this.handleCustomerCreateJobClick.bind(this, data));
            }
            if (customerTitle) {
              customerTitle.classList.add('cursor-pointer', 'hover:underline', 'hover:text-blue-500');
              customerTitle.removeEventListener('click', this.handleCustomerTitleClick);
              customerTitle.addEventListener('click', this.handleCustomerTitleClick.bind(this, data));
            }
          }
          else if (module === 'asset') {
            const assetTitle: HTMLElement = popupElement.querySelector('#asset-title');
            if (assetTitle) {
              assetTitle.classList.add('cursor-pointer', 'hover:underline', 'hover:text-blue-500');
              assetTitle.removeEventListener('click', this.handleAssetTitleClick);
              assetTitle.addEventListener('click', this.handleAssetTitleClick.bind(this, data));
            }
          }
          else if (module === 'property') {
            const propertyCreateJobButton = popupElement.querySelector('#property-create-job-btn');
            const propertyTitle = popupElement.querySelector('#property-title');
            if (propertyCreateJobButton) {
              propertyCreateJobButton.removeEventListener('click', this.handlePropertyCreateJobClick);
              propertyCreateJobButton.addEventListener('click', this.handlePropertyCreateJobClick.bind(this, data));
            }
            if (propertyTitle) {
              propertyTitle.classList.add('cursor-pointer', 'hover:underline', 'hover:text-blue-500');
              propertyTitle.removeEventListener('click', this.handlePropertyTitleClick);
              propertyTitle.addEventListener('click', this.handlePropertyTitleClick.bind(this, data));
            }
          }
          else if (module === 'user') {
            const userTitle = popupElement.querySelector('#user-title');
            const userCreateJobButton = popupElement.querySelector('#user-create-job-btn');
            if (userTitle) {
              userTitle.classList.add('cursor-pointer', 'hover:underline', 'hover:text-blue-500');
              userTitle.removeEventListener('click', this.handleUserTitleClick);
              userTitle.addEventListener('click', this.handleUserTitleClick.bind(this, data));
            }
            if (userCreateJobButton) {
              userCreateJobButton.removeEventListener('click', this.handleUserCreateJobClick);
              userCreateJobButton.addEventListener('click', this.handleUserCreateJobClick.bind(this, data));
            }
          }
        }
      }
    }
  }

  handleCustomerCreateJobClick(data: any): void {
    this._MapService.newJobDrawerToggler.next({ module: 'CUSTOMER', data });
  }

  handlePropertyCreateJobClick(data: any): void {
    this._MapService.newJobDrawerToggler.next({ module: 'PROPERTY', data });
  }

  handleUserCreateJobClick(data: any): void {
    this._MapService.newJobDrawerToggler.next({ module: 'EMPLOYEE', data });
  }

  handleCustomerTitleClick(data: any): void {
    this._MapService.previewUid.next({ uid: data.customer_uid, module: 'CUSTOMER' });
  }

  handleAssetTitleClick(data: any): void {
    this._MapService.previewUid.next({ uid: data?.asset_uid, module: 'ASSETS' });
  }

  handlePropertyTitleClick(data: any): void {
    this._MapService.previewUid.next({ uid: data?.property_uid, module: 'PROPERTY' });
  }

  handleUserTitleClick(data: any): void {
    this._MapService.previewUid.next({ uid: data?.user_uid, module: 'USER' });
  }

  handleJobTitleClick(data: any): void {
    this._MapService.previewUid.next({ uid: data?.job_uid, module: 'JOB' });
  }

  handleRouteTitleClick(data: any): void {
    this._dispatchBoardService.previewRouteDetails.set({ show: true, routeDetailsUid: data?.route_uid, source: 'map' });
  }

  getCustomerLocationData(): void {
    this.customerLocationData = this._MapService.customerLocationData
      .pipe(map((res: any) => res?.filter((customerDetails: any) => this.utilityService.isValidGeoCords(customerDetails?.customer_address?.geo_cordinates))))
      .subscribe({
        next: (res) => {
          if (res) {
            this.updateLegendDetails('customers', res);
            const newCustomerMarkersMap = new Map<string, any>();
            res.forEach(customerDetails => newCustomerMarkersMap.set(customerDetails.customer_uid, customerDetails));

            const markersToRemove = [];
            this.customerMarkersMap.forEach((existingMarker, customerUid) => {
              if (!newCustomerMarkersMap.has(customerUid)) {
                markersToRemove.push(existingMarker);
                this.customerMarkersMap.delete(customerUid);
              }
            });

            const markersToAdd = [];
            newCustomerMarkersMap.forEach((customerDetails, customerUid) => {
              const existingMarker = this.customerMarkersMap.get(customerUid);
              if (existingMarker) {
                if (existingMarker?.options?.customer?.updated_at !== customerDetails?.updated_at ||
                  !_.isEqual(existingMarker?.options?.customer?.color_profile, customerDetails?.color_profile)
                ) {
                  markersToRemove.push(existingMarker);
                  this.customerMarkersMap.delete(customerUid);
                  const marker = this.createCustomerMarker(customerDetails);
                  if (marker) {
                    markersToAdd.push(marker);
                  }
                }
              } else {
                const marker = this.createCustomerMarker(customerDetails);
                if (marker) {
                  markersToAdd.push(marker);
                }
              }
            });

            if (markersToRemove?.length) {
              const layerGroupToRemove = L.layerGroup(markersToRemove);
              this.customerLayerGroup.removeLayer(layerGroupToRemove);
              this.markerCluster.removeLayer(layerGroupToRemove);
            }

            if (markersToAdd?.length) {
              const newLayerGroup = L.layerGroup(markersToAdd);
              this.customerLayerGroup.addLayer(newLayerGroup);
              this.markerCluster.addLayer(newLayerGroup);
            }

            if (this.map.hasLayer(this.markerCluster)) {
              this.markerCluster.refreshClusters();
            } else {
              this.map.addLayer(this.markerCluster);
            }
          }
        },
        error: (err) => {
          if (err?.data?.message) { }
        }
      });
  }

  createCustomerMarker(customerDetails: any): any {
    if (this.utilityService.isValidGeoCords(customerDetails?.customer_address?.geo_cordinates)) {
      const markerIcon = this.colorProfileOptions?.isEnabled && customerDetails?.color_profile
        ? this._MapService.getCustomColorProfileIcon(customerDetails) || this.defaultCustomerIcon
        : this.defaultCustomerIcon;
      const marker = L.marker(customerDetails?.customer_address?.geo_cordinates, {
        icon: markerIcon,
        customer: customerDetails
      });
      marker.on('click', (customerMarkerInstance: any) => {
        if (!customerMarkerInstance.target.getPopup()) {
          this.bindMarkerPopup('customer', customerMarkerInstance, customerDetails);
        }
        const popup = customerMarkerInstance.target.getPopup();
        popup.on('remove', () => {
          customerMarkerInstance.target.unbindPopup();
        });
      });
      this.customerMarkersMap.set(customerDetails.customer_uid, marker);
      return marker;
    }
    return null;
  }

  getJobMarkerIcon(jobDetails: any): any {
    if (this.colorProfileOptions?.isEnabled && jobDetails?.color_profile) {
      return this._MapService.getCustomColorProfileIcon(jobDetails) || this.defaultJobMarkerIcon;
    }
    return this.defaultJobMarkerIcon;
  }

  setJobDetailsTooltipContent(jobMarkerInstance: any, jobDetails: any, additionalParam?: any): void {
    const popupOffset = L.point(5, -35);
    const popupContent: string = this._dispatchTemplateBoardService.getJobDetailsTemplate(jobDetails, 'DAY', { map: { enable_map_view: true } }, true, additionalParam);
    jobMarkerInstance.target.unbindTooltip();
    const existingPopup = jobMarkerInstance.target.getPopup();
    if (!existingPopup) {
      jobMarkerInstance.target.bindPopup(popupContent, {
        closeButton: true,
        minWidth: 250,
        offset: popupOffset,
        job: jobDetails
      });
    }
    jobMarkerInstance.target.openPopup();
    const popup = jobMarkerInstance.target.getPopup();
    if (popup) {
      const popupElement = popup.getElement();
      if (popupElement) {
        this.setEventListnersForJobPopup(popupElement, jobDetails);
      }
    }
  }

  setEventListnersForJobPopup(popupElement: any, jobDetails: any): void {
    if (popupElement) {
      const jobTitle: HTMLElement = popupElement.querySelector('#job-title');
      if (jobTitle) {
        jobTitle.classList.add('cursor-pointer', 'hover:underline', 'hover:text-blue-500');
        jobTitle.removeEventListener('click', this.handleJobTitleClick);
        jobTitle.addEventListener('click', this.handleJobTitleClick.bind(this, jobDetails));
      }
      const closeButton = popupElement.querySelector('.leaflet-popup-close-button');
      if (closeButton) {
        closeButton.removeEventListener('click', this.handleCloseButtonClick);
        closeButton.addEventListener('click', this.handleCloseButtonClick);
      }
    }
  }
  setRouteHomeTooltipContent(routeHomeMarkerInstance: any, routeDetails: any): any {
    const popupOffset = L.point(5, -35);
    const popupContent: string = this._dispatchTemplateBoardService.getRouteHomePopupContent(routeDetails, this.drawOnMapNavbarData.selectedJobs?.length || 0, this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab]);
    routeHomeMarkerInstance.target.unbindTooltip();
    routeHomeMarkerInstance.target.bindPopup(popupContent, {
      closeButton: true,
      minWidth: 250,
      offset: popupOffset
    });
    routeHomeMarkerInstance.target.openPopup();
    this.drawOnMapNavbarData.selectedRoute = routeDetails;
    this.drawOnMapNavbarData.routeHomeMarkerInstance = routeHomeMarkerInstance;
    const popup = routeHomeMarkerInstance.target.getPopup();
    setTimeout(() => {
      if (popup) {
        const popupElement = popup.getElement();
        if (popupElement) {
        const routeTitle: HTMLElement = popupElement.querySelector('#route-title');
        if (routeTitle) {
          routeTitle.classList.add('cursor-pointer', 'hover:underline', 'hover:text-blue-500');
          routeTitle.removeEventListener('click', this.handleRouteTitleClick);
          routeTitle.addEventListener('click', this.handleRouteTitleClick.bind(this, routeDetails));
        }
          const addJobToRouteButton = popupElement.querySelector('#add-job-to-route-btn');
          const closeButton = popupElement.querySelector('.leaflet-popup-close-button');
          if (addJobToRouteButton) {
            addJobToRouteButton.removeEventListener('click', this.addJobsToRouteClickEvent);
            addJobToRouteButton.addEventListener('click', this.addJobsToRouteClickEvent);
          }
          if (closeButton) {
            closeButton.removeEventListener('click', this.handleCloseButtonClick);
            closeButton.addEventListener('click', this.handleCloseButtonClick);
          }
        }
      }
    });
    return popup;
  }

  setRouteDestinationTooltipContent(routeMarkerInstance: any, routeDetails: any): any {
    const popupOffset = L.point(5, -35);
    const popupContent: string = this._dispatchTemplateBoardService.getRouteDestinationPopupContent(routeDetails, this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab]);
    routeMarkerInstance.target.unbindTooltip();
    routeMarkerInstance.target.bindPopup(popupContent, {
      closeButton: true,
      minWidth: 250,
      offset: popupOffset
    });
    routeMarkerInstance.target.openPopup();
    const popup = routeMarkerInstance.target.getPopup();
    if (popup) {
      const popupElement = popup.getElement();
      if (popupElement) {
        const closeButton = popupElement.querySelector('.leaflet-popup-close-button');
        if (closeButton) {
          closeButton.removeEventListener('click', this.handleCloseButtonClick);
          closeButton.addEventListener('click', this.handleCloseButtonClick);
        }
      }
    }
    return popup;
  }


  updateLegendDetails(module: 'assets' | 'customers' | 'jobs' | 'properties' | null, eventDetails: any[], reset: boolean = false, resetAll: boolean = false): void {
    if (resetAll) {
      if (this.legendDetails) {
        Object.keys(this.legendDetails).forEach((moduleKey: any) => {
          this.legendDetails[moduleKey] = {};
        });
      }
      return;
    }
    if (reset) {
      this.legendDetails[module] = {};
      return;
    }
    if (module && eventDetails) {
      const colorProfiles = {};
      eventDetails?.forEach((eventDetail: any) => {
        const colorProfileUid: string = eventDetail?.color_profile?.color_profile_uid;
        if (colorProfileUid) {
          colorProfiles[colorProfileUid] = eventDetail?.color_profile;
        }
      });
      this.legendDetails[module] = colorProfiles;
    }
    this.eventChange.next({ event: 'LEGEND', isOpen: this._MapService.isLegendBarOpen, legendDetails: this.legendDetails });
  }

  getJobLocationData(): void {
    this.jobLocationData = this._MapService.jobLocationData
      .pipe(
        debounceTime(250),
        map((data: any) => Array.isArray(data) ? data : (_.isPlainObject(data) && data?.data && Array.isArray(data?.data)) ? data?.data : data),
        map((jobData: any) => jobData.filter((jobDetails: any) => this.utilityService.isValidGeoCords(jobDetails?.customer_address?.geo_cordinates) && !(this.enableDrawToCreateRoute && (jobDetails?.route || jobDetails?.route?.route_uid))))
      )
      .subscribe({
        next: (res) => {
          this.updateLegendDetails('jobs', res);
          const newJobMarkersMap = new Map<string, any>();
          res.forEach((jobDetails: any) => newJobMarkersMap.set(jobDetails.job_uid, jobDetails));
          const markersToRemove = [];
          this.jobMarkersMap.forEach((existingMarker, jobUid) => {
            if (!newJobMarkersMap.has(jobUid)) {
              markersToRemove.push(existingMarker);
              this.jobMarkersMap.delete(jobUid);
            }
          });

          const markersToAdd = [];
          newJobMarkersMap.forEach((jobDetails, jobUid) => {
            const existingMarker = this.jobMarkersMap.get(jobUid);
            if (existingMarker) {
              if (existingMarker?.options?.job?.updated_at !== jobDetails?.updated_at ||
                !_.isEqual(existingMarker?.options?.job?.color_profile, jobDetails?.color_profile)) {
                markersToRemove.push(existingMarker);
                this.jobMarkersMap.delete(jobUid);
                const newMarker = this.createJobMarker(jobDetails)
                if (newMarker) {
                  markersToAdd.push(this.createJobMarker(jobDetails));
                }
              }
            } else {
              const newMarker = this.createJobMarker(jobDetails)
              if (newMarker) {
                markersToAdd.push(this.createJobMarker(jobDetails));
              }
            }
          });

          if (markersToRemove?.length) {
            const layerGroupToRemove = L.layerGroup(markersToRemove);
            this.jobLayerGroup.removeLayer(layerGroupToRemove);
            this.markerCluster.removeLayer(layerGroupToRemove);
          }

          if (markersToAdd?.length) {
            const newLayerGroup = L.layerGroup(markersToAdd);
            this.jobLayerGroup.addLayer(newLayerGroup);
            this.markerCluster.addLayer(newLayerGroup);
          }

          if (this.map.hasLayer(this.markerCluster)) {
            this.markerCluster.refreshClusters([...markersToAdd, ...markersToRemove]);
          } else {
            this.map.addLayer(this.markerCluster);
          }
          this._MapService.showOnMap.next({ module: 'JOBS', eventUid: this._MapService.openTooltip.jobUid });
        },
        error: (err) => {
          if (err?.data?.message) { }
        }
      });
  }

  createJobMarker(jobDetails: any): any {
    const coordinates = jobDetails?.customer_address?.geo_cordinates;
    const markerIcon = this.isDispatch ? this.getJobMarkerIcon(jobDetails) : this.defaultJobMarkerIcon;
    const marker = L.marker(coordinates, {
      icon: markerIcon,
      job: jobDetails,
    });

    if (this.isDispatch) {
      marker.on('click', (jobMarkerInstance: any) => {
        if (!jobMarkerInstance.target.getPopup()) {
          this.setJobDetailsTooltipContent(jobMarkerInstance, jobDetails);
        }
        this._MapService.openTooltip.jobUid = null;

        const popup = jobMarkerInstance.target.getPopup();
        popup.on('remove', (removedMarker: any) => {
          const jobUid = removedMarker.target?.options?.job?.job_uid;
          if (!this.customJobSelection.enable || !this.customJobSelection.selectedJobAndMarker?.[jobUid]) {
            jobMarkerInstance.target.unbindPopup();
          }
        });

        if (this.customJobSelection.enable) {
          this.drawOnMapNavbarData.toggleNavBar = true;
          this.addOrRemoveSelectedJob(jobMarkerInstance);
        } else {
          this.jobSelected.emit(jobDetails);
        }
      });

      marker.on('mouseover', (jobMarkerInstance: any) => {
        if (this.customJobSelection.enable) {
          if (!jobMarkerInstance.target.getPopup()) {
            this.setJobDetailsTooltipContent(jobMarkerInstance, jobDetails);
          } else {
            jobMarkerInstance.target.openPopup();
          }
        }
      });

      marker.on('mouseout', (jobMarkerInstance: any) => {
        if (this.customJobSelection.enable) {
          jobMarkerInstance.target.closePopup();
        }
      });
    } else {
      const markerPopup = this.compilePopup(JobPopupComponent, (c) => {
        c.instance.data = jobDetails;
        c.instance.timezone = this.timezone;
      });
      const popup = R.responsivePopup({ minWidth: 280, offset: [5, -35] }).setContent(markerPopup);

      marker.bindPopup(popup).on('popupopen', () => {
        this.jobSelected.emit(jobDetails);
      });
    }

    this.jobMarkersMap.set(jobDetails?.job_uid, marker);
    this.jobGroupsMarker.push(marker);
    return marker;
  }

  openSpecificJobMarkerPopup(marker: L.Marker | null): void {
    if (!marker) {
      return;
    }
    this.previousZoom = 18;
    const openAndSetupPopup = () => {
      marker.openPopup();
      // Need to wait for the popup to be opened before setting event listeners
      setTimeout(() => this.setEventListnersForJobPopup(marker.getPopup()?.getElement(), marker.options?.job), 500);
    };

    if (this.markerCluster.hasLayer(marker)) {
      this.map.setView(marker.getLatLng(), this.map.getMaxZoom());
      // Need to wait for the map to be zoomed in before showing the popup
      setTimeout(() => {
        this.markerCluster.zoomToShowLayer(marker, () => {
          openAndSetupPopup();
        });
      }, 500);
    } else {
      this.map.panTo(marker.getLatLng());
      openAndSetupPopup();
    }
  }

  preventPopupCloseBtnClick(marker: any): void {
    const popup = marker.getPopup();
    if (popup) {
      popup.on('remove', () => {
        marker.unbindPopup();
      });
      const popupElement = popup.getElement();
      if (popupElement) {
        const closeButton = popupElement.querySelector('.leaflet-popup-close-button');
        if (closeButton) {
          if (marker._closeButtonHandler) {
            closeButton.removeEventListener('click', marker._closeButtonHandler);
          }
          marker._closeButtonHandler = (event: MouseEvent): any => this.handleCloseButtonClick(event, marker);
          closeButton.addEventListener('click', marker._closeButtonHandler);
        }
      }
    }
  }

  handleCloseButtonClick = (event: MouseEvent, marker: any): void => {
    event.stopPropagation();
    event.preventDefault();
    if (!marker) {
      this._MapService.openTooltip.jobUid = null;
      this._MapService.openTooltip.routeUid = null;
    }
    if (marker?.options?.job?.job_uid === this._MapService.openTooltip.jobUid) {
      this._MapService.openTooltip.jobUid = null;
    }
    if (marker?.options?.route?.route_uid === this._MapService.openTooltip.routeUid) {
      this._MapService.openTooltip.routeUid = null;
    }
  };

  getPropertyLocationData(): void {
    this.propertyLocationData = this._MapService.propertyLocationData
    .pipe(map((res: any) => res.filter((data: any) => this.utilityService.isValidGeoCords(data?.property_address?.geo_cordinates))))
    .subscribe({
      next: (res) => {
        if (res) {
          this.updateLegendDetails('properties', res);
          const newPropertyMarkersMap = new Map<string, any>();
          res.forEach((propertyDetails: any) => newPropertyMarkersMap.set(propertyDetails.property_uid, propertyDetails));
  
          const markersToRemove = [];
          this.propertyMarkersMap.forEach((existingMarker, propertyUid) => {
            if (!newPropertyMarkersMap.has(propertyUid)) {
              markersToRemove.push(existingMarker);
              this.propertyMarkersMap.delete(propertyUid);
            }
          });
  
          const markersToAdd = [];
          newPropertyMarkersMap.forEach((propertyDetails, propertyUid) => {
            const existingMarker = this.propertyMarkersMap.get(propertyUid);
            if (existingMarker) {
              if (existingMarker?.options?.property?.updated_at !== propertyDetails?.updated_at ||
                !_.isEqual(existingMarker?.options?.property?.color_profile, propertyDetails?.color_profile)
              ) {
                markersToRemove.push(existingMarker);
                this.propertyMarkersMap.delete(propertyUid);
                const newMarker = this.createPropertyMarker(propertyDetails);
                if (newMarker) {
                  markersToAdd.push(newMarker);
                }
              }
            } else {
              const newMarker = this.createPropertyMarker(propertyDetails);
              if (newMarker) {
                markersToAdd.push(newMarker);
              }
            }
          });
  
          if (markersToRemove?.length) {
            const layerGroupToRemove = L.layerGroup(markersToRemove);
            this.propertyLayerGroup.removeLayer(layerGroupToRemove);
            this.markerCluster.removeLayer(layerGroupToRemove);
          }
  
          if (markersToAdd?.length) {
            const newLayerGroup = L.layerGroup(markersToAdd);
            this.propertyLayerGroup.addLayer(newLayerGroup);
            this.markerCluster.addLayer(newLayerGroup);
          }
  
          if (this.map.hasLayer(this.markerCluster)) {
            this.markerCluster.refreshClusters();
          } else {
            this.map.addLayer(this.markerCluster);
          }
        }
      },
      error: (err) => {
        if (err?.data?.message) { }
      }
    });
  }

  createPropertyMarker(propertyDetails: any): any {
    if (this.utilityService.isValidGeoCords(propertyDetails?.property_address?.geo_cordinates)) {
      let markerIcon = this.defaultPropertyIcon;
      if (this.colorProfileOptions?.isEnabled && propertyDetails?.color_profile) {
        markerIcon = this._MapService.getCustomColorProfileIcon(propertyDetails);
        if (!markerIcon) {
          markerIcon = this.defaultPropertyIcon;
        }
      }
      const marker = L.marker(propertyDetails?.property_address?.geo_cordinates, {
        icon: markerIcon,
        property: propertyDetails
      });
      marker.on('click', (propertyMarkerInstance: any) => {
        if (!propertyMarkerInstance.target.getPopup()) {
          this.bindMarkerPopup('property', propertyMarkerInstance, propertyDetails);
        }
        const popup = propertyMarkerInstance.target.getPopup();
        popup.on('remove', () => {
          propertyMarkerInstance.target.unbindPopup();
        });
      });
      this.propertyMarkersMap.set(propertyDetails.property_uid, marker);
      return marker;
    }
    return null;
  }

  getAssetLocationData(): void {
    this.assetLocationData = this._MapService.assetLocationData
      .pipe(
        map((res: any) => res.filter((data: any) => this.utilityService.isValidGeoCords(data?.asset_location?.geo_cordinates)))
      ).subscribe({
        next: (res: any) => {
          if (res) {
            this.updateLegendDetails('assets', res);
            const newAssetMarkersMap = new Map<string, any>();
            res.forEach((assetDetails: any) => newAssetMarkersMap.set(assetDetails.asset_uid, assetDetails));
  
            const markersToRemove = [];
            this.assetMarkersMap.forEach((existingMarker, assetUid) => {
              if (!newAssetMarkersMap.has(assetUid)) {
                markersToRemove.push(existingMarker);
                this.assetMarkersMap.delete(assetUid);
              }
            });
  
            const markersToAdd = [];
            newAssetMarkersMap.forEach((assetDetails, assetUid) => {
              if (this.utilityService.isValidGeoCords(assetDetails?.asset_location?.geo_cordinates)) {
                const existingMarker = this.assetMarkersMap.get(assetUid);
                if (existingMarker) {
                  if (existingMarker?.options?.asset?.updated_at !== assetDetails?.updated_at ||
                    !_.isEqual(existingMarker.options?.asset?.color_profile, assetDetails?.color_profile)) {
                    markersToRemove.push(existingMarker);
                    this.assetMarkersMap.delete(assetUid);
                    const newMarker = this.createAssetMarker(assetDetails)
                    if (newMarker) {
                      markersToAdd.push(newMarker);
                    }
                  }
                } else {
                  const newMarker = this.createAssetMarker(assetDetails)
                  if (newMarker) {
                    markersToAdd.push(newMarker);
                  }
                }
              }
            });
  
            if (markersToRemove?.length) {
              const layerGroupToRemove = L.layerGroup(markersToRemove);
              this.assetLayerGroup.removeLayer(layerGroupToRemove);
              this.markerCluster.removeLayer(layerGroupToRemove);
            }
  
            if (markersToAdd?.length) {
              const newLayerGroup = L.layerGroup(markersToAdd);
              this.assetLayerGroup.addLayer(newLayerGroup);
              this.markerCluster.addLayer(newLayerGroup);
            }
  
            if (this.map.hasLayer(this.markerCluster)) {
              this.markerCluster.refreshClusters();
            } else {
              this.map.addLayer(this.markerCluster);
            }
          }
        },
        error: (err) => {
          if (err?.data?.message) { }
        }
      });
  }

  createAssetMarker(assetDetails: any): any {
    if (this.utilityService.isValidGeoCords(assetDetails?.asset_location?.geo_cordinates)) {
      let markerIcon = this.defaultAssetIcon;
      if (this.colorProfileOptions?.isEnabled && assetDetails?.color_profile) {
        markerIcon = this._MapService.getCustomColorProfileIcon(assetDetails);
        if (!markerIcon) {
          markerIcon = this.defaultAssetIcon;
        }
      }
      const marker = L.marker(assetDetails?.asset_location?.geo_cordinates, {
        icon: markerIcon,
        asset: assetDetails
      });
      marker.on('click', (assetMarkerInstance: any) => {
        if (!assetMarkerInstance.target.getPopup()) {
          this.bindMarkerPopup('asset', assetMarkerInstance, assetDetails);
        }
        const popup = assetMarkerInstance.target.getPopup();
        popup.on('remove', () => {
          assetMarkerInstance.target.unbindPopup();
        });
      });
      this.assetMarkersMap.set(assetDetails.asset_uid, marker);
      return marker;
    }
    return null;
  }

  createEmployeeMarker(data: any): any {
    if (data?.location_data?.latitude && data?.location_data?.longitude) {
      //Initializing Icon
      const icon = L.divIcon({
        className: 'custom-div-icon',
        html: this._MapService.getEmployeeIcon(data, true),
        iconSize: [24, 42],
        iconAnchor: [15, 42]
      });

      const marker = L.marker([data.location_data?.latitude, data.location_data?.longitude], {
        icon: icon,
        user: data
      });
      if (this.isDispatch) {
        marker.on('click', (userMarkerInstance: any) => {
          if (!userMarkerInstance.target.getPopup()) {
            this.bindMarkerPopup('user', userMarkerInstance, data);
          }
          const popup = userMarkerInstance.target.getPopup();
          popup.on('remove', () => {
            userMarkerInstance.target.unbindPopup();
          });
        });
      } else {
        const markerPopup: any = this.compilePopup(EmployeePopupComponent, (c) => { c.instance.data = data; });
        //Initializing Popup
        const popup = R.responsivePopup({ minWidth: 320, offset: [5, -35] }).setContent(markerPopup);
        //Creating marker and binding events
        marker.bindPopup(popup);
      }

      this.employeeMarkersMap.set(data?.user_uid, marker);
      return marker;
    }
    return null;
  }

  getEmployeeLocationData(): void {
    this.employeeLocationData = this._MapService.employeeLocationData
      .pipe(
        map((res: any) => res.filter((data: any) => data?.location_data?.latitude && data?.location_data?.longitude))
      )
      .subscribe({
        next: (res) => {
          const newEmployeeMarkersMap = new Map<string, any>();
          const markersToRemove: L.Marker[] = [];
          const markersToAdd: L.Marker[] = [];
          res?.forEach((data: any) => newEmployeeMarkersMap.set(data.user_uid, data));
          this.employeeMarkersMap?.forEach((existingMarker, userUid) => {
            if (!newEmployeeMarkersMap.has(userUid)) {
              markersToRemove.push(existingMarker);
              this.employeeMarkersMap.delete(userUid);
            }
          });
          newEmployeeMarkersMap.forEach((data, userUid) => {
            const existingMarker = this.employeeMarkersMap.get(userUid);
            if (existingMarker) {
              if ((existingMarker.options.user?.location_data?.latitude !== data?.location_data?.latitude) || (existingMarker.options.user?.location_data?.longitude !== data?.location_data?.longitude)) {
                markersToRemove.push(existingMarker);
                this.employeeMarkersMap.delete(userUid);
                const newMarker = this.createEmployeeMarker(data);
                if (newMarker) {
                  markersToAdd.push(newMarker);
                }
              }
            } else {
              const newMarker = this.createEmployeeMarker(data);
              if (newMarker) {
                markersToAdd.push(newMarker);
              }
            }
          });
          if (markersToRemove.length) {
            const layerGroupToRemove = L.layerGroup(markersToRemove);
            this.employeeLayerGroup.removeLayer(layerGroupToRemove);
            this.markerCluster.removeLayer(layerGroupToRemove);
          }
          if (markersToAdd.length) {
            const newLayerGroup = L.layerGroup(markersToAdd);
            this.employeeLayerGroup.addLayer(newLayerGroup);
            this.markerCluster.addLayer(newLayerGroup);
          }
          if (this.map.hasLayer(this.markerCluster)) {
            this.markerCluster.refreshClusters();
          } else {
            this.map.addLayer(this.markerCluster);
          }
        },
        error: (err) => {
          if (err?.data?.message) {
            console.error('Error loading employee location data:', err.data.message);
          }
        }
      });
  }

  setMapView(data: any): void {
    if (data?.latitude && data?.longitude && !this.isDispatch) {
      this.map.setView([data.latitude, data.longitude - 0 + 0.035], 13);
    } else if (data?.latitude && data?.longitude && this.isDispatch) {
      this.map.setView([data.latitude, data.longitude], 16);
    }
  }

  getPreview(): void {
    this.drawerPreviewUid = this._MapService.previewUid.subscribe((res: any) => {
      if(this.isDispatch) {
        this._MapService.openPreviewDetailsInDispatchBoard.next({ openDrawer: !!res, previewUid: res['uid'], module: res['module'] });
        return;
      }
      if (res?.data) {
        this.currentRoute = res?.data;
        this.openRouteDetails = true;
        return;
      }
      if (res === false) {
        this.openDrawer = false;
      } else {
        this.moduleUid = res['uid'];
        this.drawerModule = res['module'];
        if (res?.canEdit) {
          this.previewOptions['allowToEdit'] = true;
        } else {
          this.previewOptions['allowToEdit'] = false;
        }
        this.previewOptions['menuOptions'] = {
          viewDetails: true,
          delete: false,
          clone: false
        };
        this.openDrawer = true;
      }
    });
  }

  getSidebarState(): void {
    this.sidebarState = this._MapService.sidebar.subscribe((res) => {
      if (res === false) { setTimeout(() => { this.map.invalidateSize(); }, 400); }
    });
  }

  getMarkerState(): void {
    this.markerState = this._MapService.markerStatus.subscribe((res) => {
      for (const key in res.modules) {
        if (key === 'EMPLOYEE' && res.current_tab !== 'EMPLOYEE') {
          if (res.states[key]) {
            this.markerCluster.addLayers(this.employeeGroupsMarker);
            // this.markerCluster.refreshClusters();
          } else {
            if (this.employeeLayerGroup) {
              this.markerCluster.removeLayer(this.employeeGroupsMarker);
              this.markerCluster.removeLayer(this.employeeLayerGroup);
              // this.markerCluster.refreshClusters();
            }
          }
        } else if (key === 'JOBS' && res.current_tab !== 'JOBS') {
          if (res.states[key]) {
            this.markerCluster.addLayers(this.jobGroupsMarker);
          } else {
            if (this.jobLayerGroup) {
              this.markerCluster.removeLayer(this.jobGroupsMarker);
              this.markerCluster.removeLayer(this.jobLayerGroup);
            }
          }
        }
        else if (key === 'ASSETS' && res.current_tab !== 'ASSETS') {
          if (res.states[key]) {
            this.markerCluster.addLayers(this.assetGroupsMarker);
          } else {
            if (this.assetLayerGroup) {
              this.markerCluster.removeLayer(this.assetGroupsMarker);
              this.markerCluster.removeLayer(this.assetLayerGroup);
            }
          }
        }
        else if (key === 'PROPERTY' && res.current_tab !== 'PROPERTY') {
          if (res.states[key]) {
            this.markerCluster.addLayers(this.propertyGroupsMarkers);
          } else {
            if (this.propertyLayerGroup) {
              this.markerCluster.removeLayer(this.propertyGroupsMarkers);
              this.markerCluster.removeLayer(this.propertyLayerGroup);
            }
          }
        }
        else if (key === 'ORGANIZATION' && res.current_tab !== 'ORGANIZATION') {
          if (res.states[key]) {
            this.markerCluster.addLayers(this.organizationGroupsMarker);
          } else {
            if (this.organizationLayerGroup) {
              this.markerCluster.removeLayer(this.organizationGroupsMarker);
              this.markerCluster.removeLayer(this.organizationLayerGroup);
            }
          }
        }
        else if (key === 'CUSTOMER' && res.current_tab !== 'CUSTOMER') {
          if (res.states[key]) {
            this.markerCluster.addLayers(this.customerGroupsMarker);
          } else {
            if (this.customerLayerGroup) {
              this.markerCluster.removeLayer(this.customerGroupsMarker);
              this.markerCluster.removeLayer(this.customerLayerGroup);
            }
          }
        }
        else if (key === 'ROUTES' && res.current_tab !== 'ROUTES') {
          if (res.states[key]) {
            if (this.routeLayerGroup) {
              this.map.addLayer(this.routeLayerGroup);
            }
          } else {
            if (this.routeLayerGroup) {
              this.map.removeLayer(this.routeLayerGroup);
            }
          }
        }
      }
    });
  }

  isMarkerInsidePolygon(latLng: any, polygon: any): boolean {
    const x = latLng.lat, y = latLng.lng;
    let inside = false;
    const polyPoints = polygon.getLatLngs()[0];
    for (let i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
      const xi = polyPoints[i].lat, yi = polyPoints[i].lng;
      const xj = polyPoints[j].lat, yj = polyPoints[j].lng;
  
      const intersect = ((yi > y) !== (yj > y)) &&
        (x < ((xj - xi) * (y - yi)) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }

  isMarkerInsideCircle(marker: any, circle: any): boolean {
    const markerLatLng = marker.getLatLng();
    const circleCenter = circle.getLatLng();
    const radius = circle.getRadius();    
    const distanceToCenter = markerLatLng.distanceTo(circleCenter);
    return distanceToCenter <= radius;
  }

  //Routes
  getRouteJobMarker(routeDetails: any, data: any, jobCount: number): void {
    //Initializing Icon
    const color = routeDetails?.color?.hex ? '#' + routeDetails.color.hex : routeDetails?.color;
    const icon = L.divIcon({
      className: 'custom-div-icon',
      html: this._MapService.getRouteJobIcon(color, jobCount),
      iconSize: [40, 52],
      iconAnchor: [15, 42]
    });

    //Creating marker and binding events
    const [routeJobLat, routeJobLng] = data?.geo_cords;
    const jobGeoCords = this.getRouteMarkerGeoCords(routeJobLat, routeJobLng);
    const routeJobMarker = L.marker(jobGeoCords, {
      icon: icon,
      isRouteJob: true,
      job: data?.job,
      jobUid: data?.job_uid
    });
    routeJobMarker.on('click', (jobMarkerInstance: any) => {
      const jobDetails: any = jobMarkerInstance.target.options?.job;
      const jobUid: any = jobMarkerInstance.target.options?.jobUid;
      if (!jobDetails && jobUid) {
        const loadingPopupContent: string = `<div class='flex items-center justify-center'>${this.utilityService.getLocaleValue('text.loading', 'Loading')}</div>`;
        jobMarkerInstance.target.bindPopup(loadingPopupContent, {
          closeButton: true,
          minWidth: 250,
          minHeight: 250,
          offset:  L.point(5, -35),
          job: jobDetails,
          jobUid:  data?.job_uid
        });
        jobMarkerInstance.target.openPopup();
        const popup = jobMarkerInstance.target.getPopup();
        if (popup) {
          const popupElement = popup.getElement();
          if (popupElement) {
            const closeButton = popupElement.querySelector('.leaflet-popup-close-button');
            if (closeButton) {
              closeButton.removeEventListener('click', this.handleCloseButtonClick);
              closeButton.addEventListener('click', this.handleCloseButtonClick);
            }
          }
        }
        this._dispatchBoardService.getJobDetails(jobUid).subscribe((response: any) => {
          const popupContent: string = this._dispatchTemplateBoardService.getJobDetailsTemplate(response?.data, 'DAY', { map: { enable_map_view: true } }, true, { showRouteJobNumber: true, color: color, jobCount: jobCount });
          jobMarkerInstance.target.getPopup().setContent(popupContent);
          jobMarkerInstance.target.options['job'] = response?.data;
        });
      }
      else {
        jobDetails['route'] = routeDetails;
        if (!jobMarkerInstance.target.getPopup()) {
          this.setJobDetailsTooltipContent(jobMarkerInstance, jobDetails, {showRouteJobNumber: true, color: color, jobCount: jobCount});
        }
        const popup = jobMarkerInstance.target.getPopup();
        popup.on('remove', () => {
          jobMarkerInstance.target.unbindPopup();
        });
      }
    });
    routeJobMarker.addTo(this.routeLayerGroup);
  }

  getRouteLocationData(): void {
    this.routeLocationData = this._MapService.routeLocationData
      .pipe(
        catchError(() => of([])),
        debounceTime(250),
        distinctUntilChanged((prevObj: any, currObj: any) => {
          const prev: any = prevObj?.data;
          const curr: any = currObj?.data;
          if (currObj?.forceUpdate) { return false; }
          if (currObj?.state === 'details' || currObj?.state === 'listing' || currObj === 'UPDATE_MAP_SETTINGS') { return false; }
          if (!prev && !curr) { return true; };
          if (!prev || !curr) { return false; }
          if (prev?.length !== curr?.length) { return false; }
          if (prev?.length === 0 && curr?.length === 0) { return true; };
          return prev.every((prevItem: any, index: any) => {
            const currItem = curr[index];
            if (!prevItem || !currItem) { return false; };
            if (prevItem?.route_uid !== currItem?.route_uid) { return false; };
            return _.isEqual(prevItem, currItem);
          });
        })
      )
      .subscribe({
        next: (res: any) => {
          if (this.routeLayerGroup) {
            this.map.removeLayer(this.routeLayerGroup);
            this.routeLayerGroup = '';
          }
          if (res?.data) {
            this.masterRouteCopy = res;
          }
          if (res === 'ADD_ROUTE') {
            res = {
              data: this.masterRouteCopy?.data,
              state: this.masterRouteCopy?.state || ''
            };
          } else if (res === 'REMOVE_ROUTE') {
            if (this.masterRouteCopy?.state !== 'details') {
              res = {
                data: [],
                state: this.masterRouteCopy?.state || ''
              };
            } else {
              res = {
                data: this.masterRouteCopy?.data,
                state: this.masterRouteCopy?.state || ''
              };
            }
          }
          else if (res === 'UPDATE_MAP_SETTINGS') {
            this.mapSettings = this._localStorageService.getLocalStorage('map_settings');
            res = this.masterRouteCopy;
          }
          if (res?.state === 'listing') {
            this.allRoutes = res?.data;
            const drawer = this._zuperDrawerService.getComponent('routeDetails');
            if (drawer && res?.drawerClosed) {
              drawer.close();
              this.currentRoute = null;
              this.openRouteDetails = false;
            }
          }
          const routes = res?.data || [];
          if (this.mapSettings?.overlay_routes || (res?.state === 'details') || this.isDispatch) {
            this.addRouteToMap(routes);
          }
        },
        error: (err: any) => {
          if (err?.data?.message) {
          }
        }
      });
  }

  addRouteToMap(routes: any): void {
    this.routeLayerGroup = L.layerGroup();
    this.map.addLayer(this.routeLayerGroup);
    this.routeHomeMarkersMap.clear();
    this.routeMarkerLocations.clear();
    routes?.forEach(async (route: any) => {
      if (!route?.showShimmer) {
        await this.getRoute(route?.start_location, route?.end_location, route);
      }
    });
    if (this._MapService.openTooltip.routeUid) {
      this._MapService.showOnMap.next({ module: 'ROUTES', eventUid: this._MapService.openTooltip.routeUid }); 
    }
  }

  getServiceTerritoryLocationData(): void {
    this.serviceTerritoryLocationData = this._MapService.serviceTerritoryLocationData
      .pipe(
      distinctUntilChanged((prev: any, curr: any): boolean => {
        if (prev.length !== curr.length) { return false; }
        else if(this.territoryGroup?.length) { return true; }
      }))
      .subscribe((res: any) => {
      this.serviceTerritory = res;
      this.serviceTerritory = this.serviceTerritory.filter((territory: any) => (territory?.territory_type !== 'ZIPCODE' && territory?.is_active));
      if (this.territoryLayerGroup) {
        this.map.removeLayer(this.territoryLayerGroup);
        this.territoryLayerGroup = '';
      }
      if (this.serviceTerritory?.length) {
        this.territoryGroup = [];
        this.serviceTerritory.forEach((territory: any) => {
        let marker: any;
        try {
          if (territory?.territory_type === 'GEOFENCE' && territory?.territory_coordinates?.length === 2 && !territory?.territory_coordinates.includes(null)) {
            marker = L.rectangle(territory?.territory_coordinates, { color: territory?.territory_color });
          } else if (territory?.territory_type === 'GEOFENCE' && territory?.territory_coordinates?.length > 2 && !territory?.territory_coordinates.includes(null)) {
            marker = L.polygon(territory?.territory_coordinates, { color: territory?.territory_color });
          } else if (territory?.territory_type === 'RADIUS' && territory?.territory_radius?.geo_cordinates?.length > 0 && territory?.territory_radius?.radius && !territory?.territory_radius?.geo_cordinates.includes(null)) {
            marker = L.circle(territory?.territory_radius?.geo_cordinates, { radius: territory?.territory_radius?.radius, color: territory?.territory_color });
          }
        } catch (error) {
          return; // Skip the marker if an error occurs
        }
        if (marker) {
          marker['target'] = marker;
          marker.on('click', (territoryMarkerInstance: any) => {
          if (!territoryMarkerInstance.target.getPopup()) {
            this.bindMarkerPopup('territory', territoryMarkerInstance, territory);
          }
          const popup = territoryMarkerInstance.target.getPopup();
          popup.on('remove', () => {
            territoryMarkerInstance.target.unbindPopup();
          });
          });
          this.territoryGroup.push(marker);
        }
        });
        this.territoryLayerGroup = L.layerGroup(this.territoryGroup);
        this.map.addLayer(this.territoryLayerGroup);
      }
      });
  }

  toggleTerritoryDrawer(): void {
    this.territoryDrawer = this._MapService.legendDrawerToggler.subscribe(
      (res: any) => {
        if(res === 'open'){
          this._zuperDrawerService.getComponent('legendDrawer').open();
        }
      }
    );
  }

  toggleNewJobDrawer(): void {
    this.jobDrawer = this._MapService.newJobDrawerToggler.subscribe(
      (res: any) => {
        if (res) {
          if (res?.module === 'EMPLOYEE') {
            this.jobObject['user'] = res?.data;
          } else {
            if (res?.data?.organization) {
              this.jobData['organization'] = res?.data?.organization;
              if (res?.data?.organization?.organization_address) {
                this.jobData['customer_billing_address'] = res?.data?.organization?.organization_address;
              }
            }
            if (res?.data?.customer_organization) {
              this.jobData['organization'] = res?.data?.customer_organization;
              if (res?.data?.customer_organization?.organization_address) {
                this.jobData['customer_billing_address'] = res?.data?.customer_organization?.organization_address;
              }
            }
            if (res?.data?.customer) {
              this.jobData['customer'] = res?.data?.customer;
              if (res?.data?.customer?.customer_address) {
                this.jobData['customer_address'] = res?.data?.customer?.customer_address;
              }
            }

            if (res?.data?.property) {
              this.jobData['property'] = res?.data?.property;
              if (res?.data?.property?.property_address) {
                this.jobData['customer_address'] = res?.data?.property?.property_address;
              }
            }
            if (res?.module === 'ASSET') {
              this.jobData['asset'] = res?.data;
            }
            if (res?.module === 'PROPERTY') {
              this.jobData['property'] = res?.data;
            }
            if (res?.module === 'CUSTOMER') {
              this.jobData['customer'] = res?.data;
            }
            if (res?.module === 'ORGANIZATION') {
              this.jobData['organization'] = res?.data;
              if (res?.data?.organization?.organization_address) {
                this.jobData['customer_address'] = res?.data?.organization?.organization_address;
              }
              if (res?.data?.organization?.organization_billing_address) {
                this.jobData['customer_billing_address'] = res?.data?.organization?.organization_billing_address;
              }
            }

          }
          this.openJob = true;
        }
      }
    );
  }

  getJobFormResult(data: any): void {
    if (data?.isDrawerClosed) {
      this.openJob = false;
      this.jobObject = {};
      this.jobData = {};
    }
    if (data?.action === 'ADVANCED_JOB' && data?.job) {
      const job: dataObj = { ...data?.job, action: 'clone', isDialog: true };
      this.zuperDialogService.openCustom(JobFormComponent, {
        data: job,
        extraClass: 'advanced-job-dialog'
      });
    }
  }

  closeLegendDrawer(): void {
    this._zuperDrawerService.getComponent('legendDrawer').close();
  }

  getRouteMarkerOffset(index: number): [number, number] {
    const offsetStep = 0.00005;
    return [index * offsetStep, -index * offsetStep];
  }

  getRouteMarkerGeoCords(lat: number, lng: number): [number, number] {
    if (!this.utilityService.isValidGeoCords([lat, lng])) {
      return null;
    }
    const locationKey = `${lat.toFixed(5)},${lng.toFixed(5)}`;
    const count = this.routeMarkerLocations.get(locationKey) || 0;
    if (count > 0) {
      const [offsetLat, offsetLng] = this.getRouteMarkerOffset(count);
      lat += offsetLat;
      lng += offsetLng;
    }
    this.routeMarkerLocations.set(locationKey, count + 1);
    return [lat, lng];
  }

  async getRoute(origin: any, destination: any, route: any): Promise<void> {

    //Home Marker
    let viaLocation = [];
    if (route?.jobs?.length > 0) {
      viaLocation = route?.jobs.map((job: any) => job?.geo_cords?.join(','));
    }
    viaLocation = _.compact(viaLocation);
    const originIcon = L.divIcon({
      className: 'custom-div-icon',
      html: this._MapService.getHomeIcon(route.color ? route.color : '#1abc9c'),
      iconSize: [30, 42],
      iconAnchor: [15, 42]
    });
    const [routeStartLat, routeStartLng] = route?.start_location?.geo_cords;
    const routeStartGeoCords = this.getRouteMarkerGeoCords(routeStartLat, routeStartLng);
    if (routeStartGeoCords) {
      const homemarker = L.marker(routeStartGeoCords, {
        icon: originIcon,
        route: route
      });
      if (this.isDispatch) {
        homemarker.on('click', (routeHomeMarkerInstance: any) => {
          if (this.drawOnMapNavbarData.selectedPolylinePopupInstance && this.drawOnMapNavbarData.selectedPolylinePopupInstance.getPopup()) {
            this.drawOnMapNavbarData.selectedPolylinePopupInstance.closePopup();
            this.drawOnMapNavbarData.selectedPolylinePopupInstance.unbindPopup();
          }
          this._MapService.openTooltip.routeUid = null;
          if (!routeHomeMarkerInstance.target.getPopup()) {
            this.setRouteHomeTooltipContent(routeHomeMarkerInstance, route);
          }
          const popup = routeHomeMarkerInstance.target.getPopup();
          popup.on('remove', () => {
            routeHomeMarkerInstance.target.unbindPopup();
          });
        });
        homemarker.addTo(this.routeLayerGroup);
        this.routeHomeMarkersMap.set(route?.route_uid, homemarker);
      }
      else {
        const homeMarkerComponent: any = this.compilePopup(OriginDestinationPopupComponent, (c) => { c.instance.data = { type: 'ORIGIN', data: route }; });
        const homeMarkerPopup = R.responsivePopup({ minWidth: 280, offset: [5, -35] }).setContent(homeMarkerComponent);
        homemarker.bindPopup(homeMarkerPopup).addTo(this.routeLayerGroup);
      }
    }

    //Destination Marker
    if (destination?.geo_cords) {
      if (this.isDispatch) {
        const [routeEndLat, routeEndLng] = destination?.geo_cords;
        const routeEndGeoCords = this.getRouteMarkerGeoCords(routeEndLat, routeEndLng);
        if (routeEndGeoCords) {
          const destinationIcon = L.divIcon({
            className: 'custom-div-icon',
            html: this._MapService.getDestinationIcon(route.color ? route.color : '#1abc9c'),
            iconSize: [40, 52],
            iconAnchor: [15, 42]
          });
          const destinationMarker = L.marker(routeEndGeoCords, {
            icon: destinationIcon,
            route: route
          });
          destinationMarker.on('click', (routeDestinationMarkerInstance: any) => {
            if (!routeDestinationMarkerInstance.target.getPopup()) {
              this.setRouteDestinationTooltipContent(routeDestinationMarkerInstance, route);
            }
            const popup = routeDestinationMarkerInstance.target.getPopup();
            popup.on('remove', () => {
              routeDestinationMarkerInstance.target.unbindPopup();
            });
          });
          destinationMarker.addTo(this.routeLayerGroup);
        }
      }
      else {
        const destinationMarkerComponent: any = this.compilePopup(OriginDestinationPopupComponent, (c) => { c.instance.data = { type: 'DESTINATION', data: route }; });
        const detinationMarkerPopup = R.responsivePopup({ minWidth: 280, offset: [5, -35] }).setContent(destinationMarkerComponent);
        const destinationIcon = L.divIcon({
          className: 'custom-div-icon',
          html: this._MapService.getDestinationIcon(route.color ? route.color : '#1abc9c'),
          iconSize: [40, 52],
          iconAnchor: [15, 42]
        });

        const destinationMarker = L.marker(destination?.geo_cords, {
          icon: destinationIcon
        }).bindPopup(detinationMarkerPopup).addTo(this.routeLayerGroup);
      }
    }

    //Jobs Marker
    if (route?.jobs?.length > 0) {
      route.jobs = route.jobs.sort((one: any, two: any) => one?.sequence - two?.sequence);
      route.jobs.forEach((data: any, index: number) => {
        this.getRouteJobMarker(route, data, index + 1);
      });
    }

    const routingParameters = {
      'routingMode': 'fast',
      'transportMode': 'car',
      'origin': origin?.geo_cords?.join(','),
      'spans': 'duration,baseDuration,length',
      'via': new H.service.Url.MultiValueQueryParameter(viaLocation),
      'return': 'polyline',
      'destination': null
    };

    if (destination?.geo_cords) {
      routingParameters['destination'] = destination?.geo_cords?.join(',');
    } else if (viaLocation?.length) {
      routingParameters['destination'] = viaLocation[viaLocation?.length - 1];
    }

    if (!this.utilityService.isEmptyOrUndefined(routingParameters.destination)) {
      let sections: any[] = [];
      if (route?.polyline) {
        sections = route?.polyline || [];
      }
      else {
        const router = this.platform.getRoutingService(null, 8);
        await router.calculateRoute(routingParameters, (data: any) => {
          if (data?.routes[0]?.['sections']) {
            sections = data.routes[0]['sections'];
          }
          else {
            sections = [];
          }
        });
      }
      sections.forEach((section) => {
        if (section?.polyline) {
          const linestring = H.util.flexiblePolyline.decode(section.polyline);
          // const seconds = section.spans[0]['duration'];
          // const hour = Math.floor(seconds/(60*60));
          // const minutes = Math.floor(seconds/60);
          // const popup = R.responsivePopup({ minWidth: 280, offset: [5,-35] }).setContent(`
          //   <p class="text-center">
          //     <span class="font-semibold text-gray-800 text-md">
          //     ETA:
          //     </span>
          //     <span class="text-md">
          //       ${hour ? hour+' Hr(s)' : ''} ${minutes ? minutes+' Min(s)' : ''}
          //     </span>
          //   </p>
          // `);
          // ANIMATED LINE
          const routeColor: string = route.color ? route.color : '#1abc9c';
          const enhancedRouteColor: string = this.utilityService.darkenHex(routeColor, 18);
          const antPolyline = L.polyline(linestring.polyline, {
            'color': routeColor,
            'weight': 5,
          });
          antPolyline.on('mouseover', (event: any) => this.onMouseOver(event, antPolyline, enhancedRouteColor));
          antPolyline.on('mouseout', (event: any) => this.onMouseOut(event, antPolyline, routeColor));
          antPolyline.on('click', (event: any) => this.onPolylineClick(event, antPolyline, route));
          antPolyline.addTo(this.routeLayerGroup);
          // this.map.fitBounds(antPolyline.getBounds(),{
          //   padding: [40, 40]
          // });
          // this.map.setMaxBounds(antPolyline.getBounds());
        }
      });
    }
  }

  onMouseOver(event: L.LeafletEvent, polyline: L.Polyline, color: string): void {
    if (this.isJobSelectedForRouteAssignment) {
      polyline.setStyle({ color: color, weight: 8 });
    }
  }

  onMouseOut(event: L.LeafletEvent, polyline: L.Polyline, color: string): void {
    if (this.isJobSelectedForRouteAssignment) {
      polyline.setStyle({ color: color, weight: 5 });
    }
  }

  onPolylineClick(event: L.LeafletMouseEvent, polyline: L.Polyline, routeDetails: any): void {
    if (this.isJobSelectedForRouteAssignment) {
      if (this.currentPolyline.popup && this.currentPolyline.popup !== polyline) {
        this.currentPolyline.popup.closePopup();
        this.currentPolyline.popup.unbindPopup();
      }
      this.currentPolyline.popup = polyline;
      this.currentPolyline.routeDetails = routeDetails;
      const latlng = event.latlng;
      const popupContent = this._dispatchTemplateBoardService.getRoutePolylineTooltipTemplate(routeDetails, this.drawOnMapNavbarData.selectedJobs?.length || 0, this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab]);
      if (!polyline.getPopup()) {
        polyline.bindPopup(popupContent, {
          closeButton: true,
          autoClose: false,
          closeOnClick: false,
          minWidth: 250
        }).openPopup(latlng);
      } else {
        polyline.getPopup()?.setContent(popupContent).setLatLng(latlng).openOn(this.map);
      }
      this.drawOnMapNavbarData.selectedPolylinePopupInstance = polyline;
      this.drawOnMapNavbarData.selectedRoute = routeDetails;
      polyline.off('popupclose');
      polyline.on('popupclose', () => {
        polyline.unbindPopup();
      });

      setTimeout(() => {
        const popup = polyline.getPopup();
        if (popup) {
          const popupElement = popup.getElement();
          if (popupElement) {
            const addJobToRouteButton = popupElement.querySelector('#add-job-to-route-btn');
            const closeButton = popupElement.querySelector('.leaflet-popup-close-button');
            if (addJobToRouteButton) {
              addJobToRouteButton.removeEventListener('click', this.addJobsToRouteClickEvent);
              addJobToRouteButton.addEventListener('click', this.addJobsToRouteClickEvent);
            }
            if (closeButton) {
              closeButton.removeEventListener('click', this.handleCloseButtonClick);
              closeButton.addEventListener('click', this.handleCloseButtonClick);
            }
          }
        }
      });
    }
    if (!polyline.hasEventListeners('popupclose')) {
      polyline.on('popupclose', () => {
        polyline.unbindPopup();
        this.currentPolyline.popup = null;
      });
    }

  }

  showClearSelectionFloatingBtn(): void {
    this.floatingActionButton.showClearBtn = true;
    this.floatingActionButton.showInfo = false;
    this.floatingActionButton.infoMessage = '';
  }

  removeFloatingInfo(): void {
    this.floatingActionButton.showInfo = false;
    this.floatingActionButton.infoMessage = '';
  }

  removeFloatingClearSelection(): void {
    this.floatingActionButton.showClearBtn = false;
  }

  formatJobDetails(jobs: any[]): any[] {
    jobs = _.uniqBy(jobs, 'job_uid');
    jobs = jobs.map((jobDetails: any) => ({
      ...jobDetails,
      name: this._dispatchBoardService.getJobTitle(jobDetails?.prefix, jobDetails?.work_order_number, jobDetails?.job_title),
      startEndTime: this._dispatchBoardService.getStartEndTime(jobDetails?.scheduled_start_time, jobDetails?.scheduled_end_time, true),
      statusFadeColor: this.utilityService.convertHexToRgba(jobDetails?.current_job_status?.status_color),
      assignedToAvatar: this._dispatchTemplateBoardService.getAssignedToAvatarView(jobDetails?.assigned_to || []),
      showDueDate: !jobDetails?.scheduled_start_time,
      dueDate: jobDetails?.due_date ? moment(jobDetails?.due_date).format(this._dispatchBoardService.dateFormat): ''
    }));
    return jobs;
  }

  initRouteJobConfirmationDialogData(selectedJobs: any[]): void {
    this.routeJobConfirmationDialogData.jobs = {};
    selectedJobs.forEach((jobDetails: any) => {
      this.routeJobConfirmationDialogData.jobs[jobDetails?.job_uid] = true;
      const geoCords = jobDetails?.customer_address?.geo_cordinates;
      this.routeJobConfirmationDialogData.geoCords[jobDetails?.job_uid] = geoCords || [];
    });
    this.updateSelectedJobCountInConfirmationDialog();
  }

  updateSelectedJobCountInConfirmationDialog(): void {
    if (!this.routeJobConfirmationDialogData.jobs) {
      this.routeJobConfirmationDialogData.jobs = {};
    }
    this.routeJobConfirmationDialogData.selectedJobCount = Object.values(this.routeJobConfirmationDialogData.jobs).filter(Boolean).length;
  }

  addRouteJobSelectionChange($event: any, jobDetails: any): void {
    this.routeJobConfirmationDialogData.jobs[jobDetails?.job_uid] = $event?.target?.checked ?? false;
    if ($event?.target?.checked) {
      this.routeJobConfirmationDialogData.geoCords[jobDetails?.job_uid] = jobDetails?.customer_address?.geo_cordinates || [];
    }
    else {
      delete this.routeJobConfirmationDialogData.geoCords[jobDetails?.job_uid];
    }
    this.updateSelectedJobCountInConfirmationDialog();

  }

  addJobsToRouteClickEvent = (event: any): void => {
    if (this.drawOnMapNavbarData.selectedPolylinePopupInstance) {
      this.drawOnMapNavbarData.selectedPolylinePopupInstance.closePopup();
      this.drawOnMapNavbarData.selectedPolylinePopupInstance.unbindPopup();
    }
    if(this.drawOnMapNavbarData.routeHomeMarkerInstance) {
      this.drawOnMapNavbarData.routeHomeMarkerInstance.target.closePopup();
      this.drawOnMapNavbarData.routeHomeMarkerInstance.target.unbindPopup();
    }
    let selectedJobs = this.drawOnMapNavbarData.selectedJobs.map((selectedJob: any) => selectedJob?.job);
    selectedJobs = this.formatJobDetails(selectedJobs);
    this.initRouteJobConfirmationDialogData(selectedJobs);
    this.routeJobConfirmationDialogData.selectedRoute = this.drawOnMapNavbarData.selectedRoute;
    this.routeJobConfirmationDialogData.dialogInstance = this.matDialog.open(this.routeAddJobConfirmationDialogContent, {
      panelClass: ['route-job-confirm-dialog'],
      disableClose: false,
      data: { selectedRoute: this.drawOnMapNavbarData.selectedRoute, selectedJobs: selectedJobs }
    });
    this.routeJobConfirmationDialogData.dialogInstance.afterClosed().subscribe((isClosed: boolean) => {
      if (isClosed) {
        this.routeJobConfirmationDialogData = { dialogInstance: null, jobs: {}, selectedJobCount: 0, geoCords: {}, selectedRoute: null};
        this.clearDrawOnMap();
      }
    });
  };

  closeAddJobConfirmationDialog(): void {
    if (this.routeJobConfirmationDialogData.dialogInstance) {
      this.routeJobConfirmationDialogData.dialogInstance.close();
    }
  }

  onRouteAddJobCompleted(): void {
    const selectedJobUids: any[] = Object.keys(this.routeJobConfirmationDialogData.geoCords);
    const targetRouteUid: string = this.routeJobConfirmationDialogData.selectedRoute?.route_uid;
    if (targetRouteUid) {
      if (selectedJobUids?.length) {
        const payload = { jobs: [] };
        selectedJobUids.forEach((jobUid: any) => {
          if (this.routeJobConfirmationDialogData.geoCords[jobUid]) {
            payload.jobs.push({ job_uid: jobUid, geo_cords: this.routeJobConfirmationDialogData.geoCords[jobUid] });
          }
        });
        const routeUpdateLoadingToast = this._toast.loading(this.utilityService.getLocaleValue('recurring_route.toast.route_jobs_updating'));
        this._dispatchBoardService.assignRouteJob(targetRouteUid, payload, (status: boolean) => {
          routeUpdateLoadingToast.close();
          if (status) {
            this.routeJobConfirmationDialogData.dialogInstance.close(true);
            this.drawCompleted.emit({
              type: 'update',
              routeUid: targetRouteUid,
              addedJobs: payload.jobs
            });
          }
        });
      }
    }
  }

  toggleNewRoute(): void {
    this.routeFormOption = {
      state: 'new',
      header: 'route.create'
    };;
    this.currentRoute = {};;
    this.currentRoute['jobs'] = this.allSelectedMarkers.map((marker: any) => ({ 'job': marker.options.job, 'geo_cords': marker?.getLatLng() }));;
    this.openNewRoute = true;
    if(this.isDispatch) {
      this.routeCreationTimezone = this._dispatchBoardService.selectedTimezone.ROUTES;
    }
  }

  onNewActionComplete(event: any): void {
    if (event?.completed) {
      this.allSelectedMarkers = [];
      this.drawnLayers?.clearLayers();
      this.routeCreated.emit(event);
    }
    this.openNewRoute = false;
    this.currentRoute = null;
  }


  //Lifecycle Hooks

  ngOnInit(): void {
    this.platform = new H.service.Platform({
      apikey: env.hereMapKey
    });
    this.mapSettings = this._localStorageService.getLocalStorage('map_settings');
    this.handleMapMovement.bind(this);
    this.handleZoomChange.bind(this);
  }

  ngAfterViewInit(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((res) => {
        if (res?.coords?.latitude && res?.coords?.longitude) {
          this.activeGeoCords = [res.coords.latitude, res.coords.longitude];
          this.initMap(true);
        }
      }, (err) => {
        this.initMap(false);
      });
    }
  }

  ngOnDestroy(): void {
    if (this.employeeLocationData?.unsubscribe) {
      this.employeeLocationData.unsubscribe();
    }
    if (this.drawerPreviewUid?.unsubscribe) {
      this.drawerPreviewUid.unsubscribe();
    }
    if (this.sidebarState?.unsubscribe) {
      this.sidebarState.unsubscribe();
    }
    if (this.assetLocationData?.unsubscribe) {
      this.assetLocationData.unsubscribe();
    }
    if (this.jobLocationData?.unsubscribe) {
      this.jobLocationData.unsubscribe();
    }
    if (this.organizationLocationData?.unsubscribe) {
      this.organizationLocationData.unsubscribe();
    }
    if (this.propertyLocationData?.unsubscribe) {
      this.propertyLocationData.unsubscribe();
    }
    if (this.customerLocationData?.unsubscribe) {
      this.customerLocationData.unsubscribe();
    }
    if (this.routeLocationData?.unsubscribe) {
      this.routeLocationData.unsubscribe();
    }
    if (this.serviceTerritoryLocationData?.unsubscribe) {
      this.serviceTerritoryLocationData.unsubscribe();
    }
    if (this.markerState?.unsubscribe) {
      this.markerState.unsubscribe();
    }
    if (this.territoryDrawer?.unsubscribe) {
      this.territoryDrawer.unsubscribe();
    }
    if (this.jobDrawer?.unsubscribe) {
      this.jobDrawer.unsubscribe();
    }
    if (this.mapResizeSubscription?.unsubscribe) {
      this.mapResizeSubscription.unsubscribe();
    }
    if (this.clearDrawLayerSubscription?.unsubscribe) {
      this.clearDrawLayerSubscription.unsubscribe();
    }
    if (this.mapFitBoundByGeoCordsSubscription?.unsubscribe) {
      this.mapFitBoundByGeoCordsSubscription.unsubscribe();
    }
    if (this.showOnMapSubscription?.unsubscribe) {
      this.showOnMapSubscription.unsubscribe();
    }
    if (this.map) {
      this.map.eachLayer((layer: any) => {
        this.map.removeLayer(layer);
      });
      this.map?.off();
      this.map?.remove();
    }

    this.toolButtons.forEach((button: any) => {
      if (button.element) {
        button.element.removeEventListener('click', () => this.toggleDrawTool(button.tool));
      }
    });
    this.updateLegendDetails(null, null, false, true);
    this._MapService.isLegendBarOpen = false;
    this._MapService.openTooltip.jobUid = null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.mapView?.currentValue !== changes?.map_view?.previousValue) {
      if (changes?.mapView?.currentValue?.latitude) {
        this.setMapView(changes.mapView.currentValue);
      }
      else if (changes?.mapView?.currentValue?.location_data?.latitude) {
        const data = {
          'latitude': changes.mapView.currentValue.location_data.latitude,
          'longitude': changes.mapView.currentValue.location_data.longitude
        };
        this.setMapView(data);
      }
      else if (changes?.mapView?.currentValue?.asset_location?.geo_cordinates) {
        const data = {
          'latitude': changes.mapView.currentValue.asset_location.geo_cordinates[0],
          'longitude': changes.mapView.currentValue.asset_location.geo_cordinates[1]
        };
        this.setMapView(data);
      }
      else if (changes?.mapView?.currentValue?.property_address?.geo_cordinates) {
        const data = {
          'latitude': changes.mapView.currentValue.property_address.geo_cordinates[0],
          'longitude': changes.mapView.currentValue.property_address.geo_cordinates[1]
        };
        this.setMapView(data);
      }
      else if (changes?.mapView?.currentValue?.customer_address?.geo_cordinates) {
        const data = {
          'latitude': changes.mapView.currentValue.customer_address.geo_cordinates[0],
          'longitude': changes.mapView.currentValue.customer_address.geo_cordinates[1]
        };
        this.setMapView(data);
      }
      else if (changes?.mapView?.currentValue?.organization_address?.geo_cordinates) {
        const data = {
          'latitude': changes.mapView.currentValue.organization_address.geo_cordinates[0],
          'longitude': changes.mapView.currentValue.organization_address.geo_cordinates[1]
        };
        this.setMapView(data);
      }
      else if (changes?.mapView?.currentValue?.start_location?.geo_cords?.length) {
        const data = {
          'latitude': changes?.mapView?.currentValue?.start_location?.geo_cords[0],
          'longitude': changes?.mapView?.currentValue?.start_location?.geo_cords[1]
        };
        this.setMapView(data);
      }
    }
  }

}
